// Arelia diamond picker — browse + ring-builder filter/grid/table UI.
// Loaded via {{ 'arelia-diamond-picker.js' | asset_url }} (see the snippet),
// NOT a {%- raw -%}{% javascript %}{%- endraw -%} block. Rationale: Shopify's compiled
// snippet-scripts.js bundle has a multi-year staleness bug (Slate #351/#415),
// is subset per-page render tree (so different templates get different/stale
// builds), and does not render Liquid. asset_url gives reliable ?v=hash cache
// busting. Same pattern as arelia-diamond-picker.css. See CLAUDE.md.

  (function () {
    const SECTION_ID = '';
    // v2 (#307): browse now defaults to grid; bumping the key drops the
    // 'table' choice every earlier visitor had saved by default.
    const STORAGE_VIEW_KEY = 'arelia-col-view-v2';

    // Industry bounds — the static fallback. fetchCatalogBounds() narrows every
    // range (including the Cut/Color/Clarity grade sliders) to live inventory.
    // Grade `labels` always stay the FULL scale, indexed by rank - 1; only
    // min/max narrow, so the sliders widen automatically if the catalog adds
    // grades later (#309).
    const BOUNDS = {
      price:   { min: 100,   max: 1000000 },
      carat:   { min: 1,     max: 10 },
      depth:   { min: 40,    max: 90 },
      table:   { min: 40,    max: 90 },
      lw:      { min: 1.00,  max: 2.75 },
      cut:     { min: 1, max: 4,  labels: ['Good','Very Good','Excellent','Ideal'] },
      color:   { min: 8, max: 10, labels: ['M','L','K','J','I','H','G','F','E','D'] },
      clarity: { min: 8, max: 11, labels: ['I2','I1','SI3','SI2','SI1','VS2','VS1','VVS2','VVS1','IF','FL'] },
    };

    // Grades shown grayed (not stocked) to the left of each grade slider, so
    // shoppers see the catalog sits at the top of the scale (CEO 2026-10-15,
    // "Grade Sliders Mockup"). Only grades below the in-stock minimum show; they
    // can't be selected, and tapping one shows GRAY_NOTE.
    const GRAYED = { cut: ['Good', 'Very Good'], color: ['J', 'I', 'H', 'G'], clarity: ['SI2', 'SI1', 'VS2', 'VS1'] };
    const GRAY_NOTE = { cut: 'Every diamond is Ideal cut, GCAL 8X', color: 'We only carry D\u2013F colorless', clarity: 'We only carry VVS2 and better' };

    // Maps our internal state key -> Shopify URL param prefix.
    const RANGE_KEYS = [
      { stateKey: 'price',        prefix: 'filter.v.price',               boundsKey: 'price' },
      { stateKey: 'carat',        prefix: 'filter.v.m.custom.carat',      boundsKey: 'carat' },
      { stateKey: 'depth_pct',    prefix: 'filter.v.m.custom.depth_pct',  boundsKey: 'depth' },
      { stateKey: 'table_pct',    prefix: 'filter.v.m.custom.table_pct',  boundsKey: 'table' },
      { stateKey: 'lw_ratio',     prefix: 'filter.v.m.custom.lw_ratio',   boundsKey: 'lw' },
      { stateKey: 'cut_rank',     prefix: 'filter.v.m.custom.cut_rank',   boundsKey: 'cut' },
      { stateKey: 'color_rank',   prefix: 'filter.v.m.custom.color_rank', boundsKey: 'color' },
      { stateKey: 'clarity_rank', prefix: 'filter.v.m.custom.clarity_rank', boundsKey: 'clarity' },
    ];

    function getRoot() { return document.querySelector('[data-ondemand-picker]'); }
    function algoliaConfig() {
      const root = getRoot();
      return {
        key: (root && root.dataset.searchKey) || '',
        index: (root && root.dataset.algoliaIndex) || 'arelia_loose_diamonds',
      };
    }
    // The page shows only the grades the site promises: D-F color (rank 8+)
    // and VVS2 or better clarity (rank 8+). All Diamonds still holds lower
    // grades until the catalog itself is gated (pricing rules O1, CEO
    // 2026-11-04); G-J and SI2-VS1 show grayed via GRAYED below.
    const GRADE_GATE = 'color_rank >= 8 AND clarity_rank >= 8';
    function catalogFilter(state) {
      const catalog = (state && state.catalog) || 'top_picks';
      const base = 'listed:true AND available:true AND ' + GRADE_GATE;
      return catalog === 'all' ? base : base + ' AND catalogs:top_picks';
    }

    // Boolean facet toggles + categorical dropdowns added 2026-04-27 (#37).
    // BOOLEAN_FILTERS map our state key → Algolia attribute name (truthy = filter).
    const BOOLEAN_FILTERS = ['is_express_shipping', 'is_overnight', 'is_on_sale', 'is_hearts_and_arrows', 'is_deal'];
    // DROPDOWN_FILTERS: stateKey → algolia facet attribute (string match)
    const DROPDOWN_FILTERS = ['growth_type', 'certificate_authority'];

    // ============================ SORT (column-header replicas, ref #40) ============================
    // URL state: ?sort=<axis>_<dir> where dir is `asc` (↑) or `desc` (↓), and
    // empty/missing = default "Featured" order via the main index
    // (featured_rank interleave of shapes x price bands, #307).
    //
    // For grade columns (cut/color/clarity) the customer-facing convention is
    // ↑ = best first. Internally rank fields are higher = better, so ↑ on a
    // grade column maps to the `_desc` replica (desc(<axis>_rank)). Document
    // the inversion in operations/storefront-filter-strategy.md § Sorting.
    const SORT_TO_REPLICA = {
      'price_asc':    'arelia_loose_diamonds_price_asc',
      'price_desc':   'arelia_loose_diamonds_price_desc',
      'carat_asc':    'arelia_loose_diamonds_carat_asc',
      'carat_desc':   'arelia_loose_diamonds_carat_desc',
      'cut_asc':      'arelia_loose_diamonds_cut_desc',
      'cut_desc':     'arelia_loose_diamonds_cut_asc',
      'color_asc':    'arelia_loose_diamonds_color_desc',
      'color_desc':   'arelia_loose_diamonds_color_asc',
      'clarity_asc':  'arelia_loose_diamonds_clarity_desc',
      'clarity_desc': 'arelia_loose_diamonds_clarity_asc',
      'shape_asc':    'arelia_loose_diamonds_shape_asc',
      'shape_desc':   'arelia_loose_diamonds_shape_desc',
      'cert_asc':     'arelia_loose_diamonds_cert_asc',
      'cert_desc':    'arelia_loose_diamonds_cert_desc',
    };
    const SORT_AXES = ['shape', 'carat', 'cut', 'color', 'clarity', 'cert', 'price'];

    function indexForSort(sort) {
      if (sort && Object.prototype.hasOwnProperty.call(SORT_TO_REPLICA, sort)) {
        return SORT_TO_REPLICA[sort] || algoliaConfig().index;
      }
      return algoliaConfig().index;
    }

    function nextSortState(currentSort, axis) {
      // Click cycle on the same axis: asc → desc → default. New axis: → asc.
      if (currentSort === axis + '_asc') return axis + '_desc';
      if (currentSort === axis + '_desc') return '';
      return axis + '_asc';
    }

    function updateSortIndicators(root, sort) {
      root.querySelectorAll('[data-sort-th]').forEach(th => {
        th.classList.remove('is-sorted', 'is-sorted-desc');
      });
      if (!sort) return;
      const m = /^(.+)_(asc|desc)$/.exec(sort);
      if (!m) return;
      const th = root.querySelector('[data-sort-th="' + m[1] + '"]');
      if (!th) return;
      th.classList.add('is-sorted');
      if (m[2] === 'desc') th.classList.add('is-sorted-desc');
    }

    // ============================ URL ↔ STATE ============================
    // Mode + locked-shape come from data attributes the snippet sets on root.
    // ring-builder mode forces shape filter to the setting's compatible_shape
    // regardless of URL state, so the customer can never escape the constraint.
    function pickerMode() {
      const r = getRoot();
      return (r && r.dataset.mode) || 'browse';
    }
    function lockedShape() {
      const r = getRoot();
      const s = (r && r.dataset.lockedShape) || '';
      return s ? s.charAt(0).toUpperCase() + s.slice(1) : '';
    }

    function currentFilterState() {
      const params = new URLSearchParams(window.location.search);
      const state = {
        shapes: params.getAll('filter.v.m.custom.shape'),
        sort: params.get('sort') || '',
        page: parseInt(params.get('page') || '1', 10),
        q: params.get('q') || '',
        catalog: params.get('catalog') === 'all' ? 'all' : 'top_picks',
      };
      RANGE_KEYS.forEach(({ stateKey, prefix }) => {
        const gte = params.get(prefix + '.gte');
        const lte = params.get(prefix + '.lte');
        if (gte !== null) state[stateKey + '_gte'] = parseFloat(gte);
        if (lte !== null) state[stateKey + '_lte'] = parseFloat(lte);
      });
      BOOLEAN_FILTERS.forEach(k => {
        if (params.get(k) === '1') state[k] = true;
      });
      DROPDOWN_FILTERS.forEach(k => {
        const v = params.get(k);
        if (v) state[k] = v;
      });
      // Ring-builder: shape is pinned to the setting's compatible_shape; the
      // shape-buttons row is hidden, and any URL params for shape are
      // overridden here so they can't fight with the lock.
      if (pickerMode() === 'ring-builder') {
        const ls = lockedShape();
        if (ls) state.shapes = [ls];
      }
      return state;
    }

    function buildUrl(overrides) {
      const merged = Object.assign(currentFilterState(), overrides || {});
      const params = new URLSearchParams();
      (merged.shapes || []).forEach(s => params.append('filter.v.m.custom.shape', s));
      RANGE_KEYS.forEach(({ stateKey, prefix, boundsKey }) => {
        const bounds = BOUNDS[boundsKey];
        const gte = merged[stateKey + '_gte'];
        const lte = merged[stateKey + '_lte'];
        if (gte !== undefined && gte > bounds.min + 1e-6) params.set(prefix + '.gte', gte);
        if (lte !== undefined && lte < bounds.max - 1e-6) params.set(prefix + '.lte', lte);
      });
      BOOLEAN_FILTERS.forEach(k => { if (merged[k]) params.set(k, '1'); });
      DROPDOWN_FILTERS.forEach(k => { if (merged[k]) params.set(k, merged[k]); });
      if (merged.q) params.set('q', merged.q);
      if (merged.sort) params.set('sort', merged.sort);
      if (merged.catalog === 'all') params.set('catalog', 'all');
      if (merged.page && merged.page > 1) params.set('page', merged.page);
      const qs = params.toString();
      return window.location.pathname + (qs ? '?' + qs : '');
    }


    // ============================ DESCRIBE-A-STONE SEARCH (2026-10-01) ============================
    // One search box, two behaviours (CEO 2026-10-01):
    //   * an identifier (digits, optionally "gdc:" / lab prefix) -> exact SKU /
    //     certificate lookup in Algolia (typo tolerance off), live as you type;
    //   * words ("2 carat oval under $3,000") -> translated by parseStoneQuery()
    //     into the page's own filters, applied on Enter. The page reloads with
    //     those filters, so every control shows how the request was understood.
    // Rules, not fuzzy search: Algolia keyword matching would treat "2" as text
    // (it matches "VVS2") and can't turn "under $3,000" into a price cap.
    function isIdentifierQuery(text) {
      return /^\s*(?:[a-z]{2,5}\s*[:#]?\s*)?\d{6,}\s*$/i.test(text || '');
    }
    const SHAPE_WORDS = { round: 'Round', rounds: 'Round', brilliant: 'Round', princess: 'Princess', princesses: 'Princess',
      cushion: 'Cushion', cushions: 'Cushion', emerald: 'Emerald', emeralds: 'Emerald', oval: 'Oval', ovals: 'Oval',
      pear: 'Pear', pears: 'Pear', teardrop: 'Pear', radiant: 'Radiant', radiants: 'Radiant', marquise: 'Marquise',
      marquises: 'Marquise', marquis: 'Marquise', asscher: 'Asscher', asschers: 'Asscher', heart: 'Heart', hearts: 'Heart' };
    const FILLER = new Set(('a an the i im i\'m want wants looking look for find show me with and or in of to my ' +
      'diamond diamonds stone stones lab grown labgrown lab-grown loose ring engagement shape cut color colour ' +
      'clarity price budget around about approx approximately roughly near ideal excellent super gcal 8x certified ' +
      'cert certificate natural please some any that is are it'
    ).split(' '));
    function parseStoneQuery(raw) {
      let text = ' ' + String(raw || '').toLowerCase().replace(/[–—]/g, '-').replace(/\s+/g, ' ') + ' ';
      const out = { shapes: [], understood: [], ignored: [] };
      const take = (re, fn) => { text = text.replace(re, (...m) => { fn(m); return ' '; }); };
      const money = (n, k) => Math.round(parseFloat(String(n).replace(/,/g, '')) * (k ? 1000 : 1));
      // Toggles
      take(/\bhearts?\s*(?:&|and|n)\s*arrows?\b|\bh\s*&\s*a\b|\bh&a\b/g, () => { out.is_hearts_and_arrows = true; });
      // Price (needs $ or k or a price word)
      const P = '\\$?\\s*(\\d[\\d,]*(?:\\.\\d+)?)\\s*(k)?';
      take(new RegExp('(?:between\\s+)?\\$\\s*(\\d[\\d,]*(?:\\.\\d+)?)\\s*(k)?\\s*(?:-|to|and)\\s*' + P, 'g'),
        m => { out.price_gte = money(m[1], m[2]); out.price_lte = money(m[3], m[4] || m[2]); });
      take(new RegExp('\\b(?:under|below|less than|up to|max(?:imum)?|no more than|<)\\s*' + P + '(?!\\s*(?:ct|carats?)\\b)', 'g'),
        m => { if (m[2] || /\$/.test(m[0]) || parseFloat(m[1].replace(/,/g, '')) >= 100) out.price_lte = money(m[1], m[2]); else out._caratMax = parseFloat(m[1]); });
      take(new RegExp('\\b(?:over|above|more than|at least|min(?:imum)?|>)\\s*' + P + '(?!\\s*(?:ct|carats?)\\b)', 'g'),
        m => { if (m[2] || /\$/.test(m[0]) || parseFloat(m[1].replace(/,/g, '')) >= 100) out.price_gte = money(m[1], m[2]); else out._caratMin = parseFloat(m[1]); });
      take(/\$\s*(\d[\d,]*(?:\.\d+)?)\s*(k)?|\b(\d[\d,]*(?:\.\d+)?)\s*k\b|\b(\d{3,}[\d,]*)\b(?!\s*(?:ct|carats?))/g,
        m => { out.price_lte = money(m[1] || m[3] || m[4], m[2] || (m[3] ? 'k' : '')); });
      // Carat
      take(/\b(\d+(?:\.\d+)?)\s*(?:-|to)\s*(\d+(?:\.\d+)?)\s*(?:ct|cts|carats?|c)\b/g,
        m => { out.carat_gte = parseFloat(m[1]); out.carat_lte = parseFloat(m[2]); });
      take(/\b(?:over|above|more than|at least|min(?:imum)?)\s*(\d+(?:\.\d+)?)\s*(?:ct|cts|carats?)?\b/g, m => { out.carat_gte = parseFloat(m[1]); });
      take(/\b(?:under|below|less than|up to|max(?:imum)?)\s*(\d+(?:\.\d+)?)\s*(?:ct|cts|carats?)?\b/g, m => { out.carat_lte = parseFloat(m[1]); });
      take(/\b(\d+(?:\.\d+)?)\s*(?:ct|cts|carats?)?\s*\+\s*(?:ct|cts|carats?)?/g, m => { out.carat_gte = parseFloat(m[1]); });
      take(/\b(\d+(?:\.\d+)?)\s*(?:ct|cts|carats?|c)\b|\b(\d(?:\.\d+)?)\b/g, m => {
        const c = parseFloat(m[1] || m[2]); if (!(c > 0 && c < 20)) return;
        const tol = c >= 2 ? 0.15 : 0.10; out.carat_gte = +(c - tol).toFixed(2); out.carat_lte = +(c + tol).toFixed(2);
      });
      if (out._caratMin) out.carat_gte = out._caratMin;
      if (out._caratMax) out.carat_lte = out._caratMax;
      // Clarity (before color so "if" isn't eaten elsewhere)
      const CL = BOUNDS.clarity.labels;
      const clRank = l => CL.indexOf(l.toUpperCase()) + 1;
      take(/\binternally flawless\b/g, () => { out.clarity_rank_gte = out.clarity_rank_lte = clRank('IF'); });
      take(/\bflawless\b/g, () => { out.clarity_rank_gte = out.clarity_rank_lte = clRank('FL'); });
      take(/\b(vvs1|vvs2|vs1|vs2|si1|si2|fl)\s*(?:-|to|or)\s*(vvs1|vvs2|vs1|vs2|si1|si2|if|fl)\b/g, m => {
        const a = clRank(m[1]), b = clRank(m[2]); out.clarity_rank_gte = Math.min(a, b); out.clarity_rank_lte = Math.max(a, b); });
      take(/\b(vvs1|vvs2|vs1|vs2|si1|si2|fl)\s*\+/g, m => { out.clarity_rank_gte = clRank(m[1]); });
      take(/\bvvs\b/g, () => { out.clarity_rank_gte = clRank('VVS2'); out.clarity_rank_lte = clRank('VVS1'); });
      take(/\b(vvs1|vvs2|vs1|vs2|si1|si2|fl)\b|(?:^|\s)(if)(?=\s+(?:clarity|diamond|stone|round|oval|$))/g, m => {
        const r = clRank(m[1] || m[2]); out.clarity_rank_gte = out.clarity_rank_lte = r; });
      // Color
      const CO = BOUNDS.color.labels;
      const coRank = l => CO.indexOf(l.toUpperCase()) + 1;
      take(/\bcolou?rless\b/g, () => { out.color_rank_gte = coRank('F'); out.color_rank_lte = coRank('D'); });
      take(/\b([d-m])\s*(?:-|to|or)\s*([d-m])\b(?:\s*colou?r)?/g, m => {
        const a = coRank(m[1]), b = coRank(m[2]); out.color_rank_gte = Math.min(a, b); out.color_rank_lte = Math.max(a, b); });
      take(/\b([d-m])\s*\+/g, m => { out.color_rank_gte = coRank(m[1]); });
      take(/\b([d-m])\b(?:\s*colou?r)?/g, m => { const r = coRank(m[1]); out.color_rank_gte = out.color_rank_lte = r; });
      // Shapes
      text = text.replace(/[a-z][a-z'-]*/g, w => {
        if (SHAPE_WORDS[w]) { if (out.shapes.indexOf(SHAPE_WORDS[w]) < 0) out.shapes.push(SHAPE_WORDS[w]); return ' '; }
        return w;
      });
      // Whatever is left: filler is dropped silently, the rest is reported.
      text.split(/[\s,.;!?()]+/).forEach(w => { if (w && !FILLER.has(w) && !/^[-&+$]+$/.test(w)) out.ignored.push(w); });
      delete out._caratMin; delete out._caratMax;
      // Clamp to what we actually stock so the note matches the controls.
      [['carat', 'carat'], ['price', 'price']].forEach(([k, bk]) => {
        const B = BOUNDS[bk];
        if (out[k + '_gte'] != null) out[k + '_gte'] = Math.min(Math.max(out[k + '_gte'], B.min), B.max);
        if (out[k + '_lte'] != null) out[k + '_lte'] = Math.max(Math.min(out[k + '_lte'], B.max), B.min);
        if (out[k + '_gte'] != null && out[k + '_gte'] <= B.min + 1e-6 && out[k + '_lte'] == null) delete out[k + '_gte'];
      });
      // Human summary of what was applied
      const u = out.understood;
      if (out.shapes.length) u.push(out.shapes.join(' or '));
      if (out.carat_gte != null || out.carat_lte != null)
        u.push(out.carat_gte != null && out.carat_lte != null ? out.carat_gte.toFixed(2) + '–' + out.carat_lte.toFixed(2) + ' ct'
          : out.carat_gte != null ? out.carat_gte.toFixed(2) + ' ct or more' : 'up to ' + out.carat_lte.toFixed(2) + ' ct');
      const lbl = (labels, r) => labels[r - 1];
      if (out.color_rank_gte != null) u.push('color ' + (out.color_rank_lte != null && out.color_rank_lte !== out.color_rank_gte
        ? lbl(CO, out.color_rank_lte) + '–' + lbl(CO, out.color_rank_gte) : out.color_rank_lte == null ? lbl(CO, out.color_rank_gte) + ' or better' : lbl(CO, out.color_rank_gte)));
      if (out.clarity_rank_gte != null) u.push(out.clarity_rank_lte != null && out.clarity_rank_lte !== out.clarity_rank_gte
        ? lbl(CL, out.clarity_rank_lte) + '–' + lbl(CL, out.clarity_rank_gte) : out.clarity_rank_lte == null ? lbl(CL, out.clarity_rank_gte) + ' or better' : lbl(CL, out.clarity_rank_gte));
      const usd = n => '$' + n.toLocaleString('en-US');
      if (out.price_gte != null || out.price_lte != null)
        u.push(out.price_gte != null && out.price_lte != null ? usd(out.price_gte) + '–' + usd(out.price_lte)
          : out.price_lte != null ? 'up to ' + usd(out.price_lte) : usd(out.price_gte) + ' or more');
      if (out.is_hearts_and_arrows) u.push('Hearts & Arrows');
      return out;
    }
    window.AreliaParseStoneQuery = parseStoneQuery;  // exposed for QA in the console
    const NL_NOTE_KEY = 'arelia-describe-note';

    // ============================ ALGOLIA ============================
    const ALGOLIA_APP_ID = '7O5GDJA5JQ';
    const ALGOLIA_HOST = 'https://' + ALGOLIA_APP_ID.toLowerCase() + '-dsn.algolia.net';

    // Replace static slider bounds with the actual catalog min/max from Algolia.
    // Uses facets_stats (pre-computed at index time, O(1) regardless of catalog
    // size). Hard 1.5s timeout falls back to the static BOUNDS so a flaky
    // network never blocks first paint.
    async function fetchCatalogBounds() {
      const ctrl = new AbortController();
      const timer = setTimeout(() => ctrl.abort(), 1500);
      try {
        // Scope matches the listing query (diamonds collection, in stock), plus
        // the setting's shape in ring-builder mode, so bounds describe what the
        // shopper can actually get — not jewelry, and not other shapes (#309).
        const scope = { filters: 'listed:true AND available:true AND ' + GRADE_GATE };
        const ls = pickerMode() === 'ring-builder' ? lockedShape() : '';
        if (ls) scope.facetFilters = [['shape:' + ls]];
        const resp = await fetch(ALGOLIA_HOST + '/1/indexes/' + algoliaConfig().index + '/query', {
          method: 'POST',
          signal: ctrl.signal,
          headers: {
            'X-Algolia-API-Key': algoliaConfig().key,
            'X-Algolia-Application-Id': ALGOLIA_APP_ID,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(Object.assign({
            query: '',
            hitsPerPage: 0,
            facets: ['price', 'carat', 'depth_pct', 'table_pct', 'lw_ratio', 'cut_rank', 'color_rank', 'clarity_rank'],
          }, scope)),
        });
        const stats = (await resp.json()).facets_stats || {};
        // Floor min / ceil max so the typed-in box can always represent the
        // actual extremes without rounding artifacts pushing the boundary.
        // Price ends rounded to friendly numbers (CEO 2026-10-15): $249 -> $200, $7,119 -> $7,500.
        if (stats.price)     { BOUNDS.price.min = Math.floor(stats.price.min / 100) * 100;      BOUNDS.price.max = Math.ceil(stats.price.max / 500) * 500; }
        if (stats.carat)     { BOUNDS.carat.min = Math.max(1, Math.floor(stats.carat.min * 100) / 100); BOUNDS.carat.max = Math.ceil(stats.carat.max * 100) / 100; }
        if (stats.depth_pct) { BOUNDS.depth.min = Math.floor(stats.depth_pct.min);              BOUNDS.depth.max = Math.ceil(stats.depth_pct.max); }
        if (stats.table_pct) { BOUNDS.table.min = Math.floor(stats.table_pct.min);              BOUNDS.table.max = Math.ceil(stats.table_pct.max); }
        if (stats.lw_ratio)  { BOUNDS.lw.min = Math.floor(stats.lw_ratio.min * 100) / 100;      BOUNDS.lw.max = Math.ceil(stats.lw_ratio.max * 100) / 100; }
        // Grade sliders show only the grades in stock (#309). Clamp to the
        // full scale so a bad record can't produce a label outside it.
        [['cut', 'cut_rank'], ['color', 'color_rank'], ['clarity', 'clarity_rank']].forEach(([k, attr]) => {
          const st = stats[attr];
          if (!st) return;
          const full = BOUNDS[k].labels.length;
          const lo = Math.max(1, Math.min(full, Math.floor(st.min)));
          const hi = Math.max(lo, Math.min(full, Math.ceil(st.max)));
          BOUNDS[k].min = lo;
          BOUNDS[k].max = hi;
        });
      } catch (e) {
        // Network error or timeout — keep the static fallback BOUNDS.
        console.warn('[arelia] fetchCatalogBounds: keeping static defaults', e && e.name);
      } finally {
        clearTimeout(timer);
      }
    }
    function shapeIconBase() {
      const root = getRoot();
      return (root && root.dataset.shapeIconBase) || '';
    }

    function stateToAlgoliaQuery(state) {
      const numericFilters = [];
      RANGE_KEYS.forEach(({ stateKey, boundsKey }) => {
        const bounds = BOUNDS[boundsKey];
        const gte = state[stateKey + '_gte'];
        const lte = state[stateKey + '_lte'];
        if (gte !== undefined && gte > bounds.min + 1e-6) numericFilters.push(stateKey + '>=' + gte);
        if (lte !== undefined && lte < bounds.max - 1e-6) numericFilters.push(stateKey + '<=' + lte);
      });
      const facetFilters = [];
      if (state.shapes && state.shapes.length) {
        facetFilters.push(state.shapes.map(s => 'shape:' + s));
      }
      BOOLEAN_FILTERS.forEach(k => {
        if (state[k]) facetFilters.push(k + ':true');
      });
      DROPDOWN_FILTERS.forEach(k => {
        if (state[k]) facetFilters.push(k + ':' + state[k]);
      });
      // The text-search box is reserved for identifier lookup only — every
      // other catalog axis (carat, price, shape, color, clarity, cut, depth,
      // table, lw, growth_type, certificate_authority, the boolean toggles)
      // already has its own filter control on the page. Restricting search
      // to sku + certificate_number eliminates the prefix-collision class
      // (e.g. typing "2.75" matching SKUs starting with "75"). When the
      // query is empty we drop the restriction so the index uses its full
      // searchableAttributes for the empty-query browse case.
      // Server-side pagination (#188): fetch only the current page (50 hits)
      // from Algolia. Shape-first ordering comes from the index's customRanking
      // (asc(shape_rank), asc(price)) on the main index, and from the selected
      // replica for column sorts — so order persists across pages without a
      // client-side full-fetch. This removes the old 1000-hit cap: the catalog
      // is now reachable to any size, one page at a time.
      const body = {
        query: state.q || '',
        hitsPerPage: PAGE_SIZE,
        page: Math.max(0, (state.page || 1) - 1),  // Algolia pages are 0-based
        facets: ['shape', 'certificate_authority', 'growth_type', 'source_wholesaler'],
        numericFilters: numericFilters,
        facetFilters: facetFilters,
        // available:true hides stones that sold since the last index push
        // (#244). Sold stones keep status=ACTIVE in Shopify, so the push-time
        // status filter alone never removed them. push_to_algolia.py also
        // drops sold records at push time; this is the storefront-side guard
        // for the window between a sale and the next index write.
        filters: catalogFilter(state),
      };
      if (state.q) {
        body.restrictSearchableAttributes = ['sku', 'certificate_number'];
        body.removeWordsIfNoResults = 'none';  // identifier lookup is exact — don't degrade to partial match
        // No typo tolerance for identifiers: by default Algolia also matched
        // certificate numbers 1-2 digits away (360166331 returned 17 stones).
        // Prefix matching still works, so a partial number narrows correctly.
        body.typoTolerance = false;
        body.allowTyposOnNumericTokens = false;
      }
      return body;
    }

    function productHref(handle) {
      var theme = new URLSearchParams(window.location.search).get('preview_theme_id');
      // Stone pages (ref #375): every listed stone lives at /a/diamonds/<handle>,
      // served by the reserve worker through the app proxy, with or without a product.
      var path = '/a/diamonds/' + handle;
      if (theme) path += '?preview_theme_id=' + encodeURIComponent(theme);
      return escHtml(path);
    }

    function escHtml(s) {
      if (s == null) return '';
      return String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    }

    function money(p) {
      const n = Number(p || 0);
      return '$' + n.toLocaleString('en-US', { maximumFractionDigits: 0 });
    }

    // Price cell. The deal treatment (strikethrough market price + -N% pill,
    // #198) was removed 2026-10-13 (CEO, ref #287): the reference price was
    // never an Arelia selling price, so it read as a former-price claim.
    function priceCell(h) {
      return money(h.price);
    }

    // Line-item properties that carry the grading report onto the cart
    // line (ref #247). `Certificate` is customer-visible (cart, checkout,
    // order confirmation); `_certificate_url` is underscore-prefixed so the
    // storefront hides it but the admin order still shows it for manual
    // fulfillment. Authority-agnostic: "GCAL #123", "IGI #456", etc.
    function certPropertyInputs(lab, number, url) {
      if (!number) return '';
      let out = '<input type="hidden" name="properties[Certificate]" value="' + escHtml((lab ? lab + ' ' : '') + '#' + number) + '">';
      if (url) out += '<input type="hidden" name="properties[_certificate_url]" value="' + escHtml(url) + '">';
      return out;
    }

    // Certificate label with the GCAL 8X grade when the stone carries it. The
    // index stores the lab as "GCAL"; the 8X grade lives in the title, which
    // the importer builds from the stone's own lab (4701ebe).
    function certLabel(h) {
      const lab = h.certificate_authority || '';
      return lab && /\bGCAL 8X\b/.test(h.title || '') ? lab + ' 8X' : lab;
    }

    // ---- Expanded-row specs (CEO 2026-10-01) ----
    // Highlights strip + Grading / Proportions groups built only from data we
    // import (GCAL certificate fields via GDC). Carat/cut/color/clarity are in
    // the row itself, so they are not repeated here.
    const GRADE_WORDS = { EX: 'Excellent', VG: 'Very Good', G: 'Good', F: 'Fair', P: 'Poor', ID: 'Ideal' };
    const FLUOR_WORDS = { N: 'None', NON: 'None', F: 'Faint', FNT: 'Faint', M: 'Medium', MED: 'Medium', S: 'Strong', STG: 'Strong', VS: 'Very Strong' };
    const gradeWord = v => GRADE_WORDS[String(v || '').toUpperCase()] || (v || '');
    const fluorWord = v => FLUOR_WORDS[String(v || '').toUpperCase()] || (v || '');
    // Typical L/W ranges (industry guidance, not certificate data). Cushion and
    // radiant come square or elongated; the stone's own ratio picks the band.
    const RATIO_GUIDE = {
      Oval: [['oval', 1.30, 1.50]], Pear: [['pear', 1.45, 1.75]], Marquise: [['marquise', 1.75, 2.25]],
      Princess: [['princess', 1.00, 1.05]], Emerald: [['emerald', 1.30, 1.50]], Asscher: [['asscher', 1.00, 1.05]],
      Heart: [['heart', 0.90, 1.10]],
      Cushion: [['square cushion', 1.00, 1.10], ['elongated cushion', 1.15, 1.40]],
      Radiant: [['square radiant', 1.00, 1.05], ['elongated radiant', 1.20, 1.50]],
    };
    function ratioGuide(shape, lw) {
      const bands = RATIO_GUIDE[shape];
      if (!bands) return '';
      const band = bands.length === 1 || !(lw > 0) ? bands[0] : (lw < 1.125 ? bands[0] : bands[1]);
      return 'Typical ' + band[0] + ': ' + band[1].toFixed(2) + '–' + band[2].toFixed(2);
    }
    function detailSpecsHtml(h, shape) {
      const isRound = shape === 'Round';
      const lw = h.lw_ratio != null && h.lw_ratio !== '' ? Number(h.lw_ratio) : NaN;
      const lwText = isNaN(lw) ? '—' : lw.toFixed(2);
      const polish = String(h.polish || '').toUpperCase(), sym = String(h.symmetry || '').toUpperCase();
      const fl = String(h.fluorescence || '').toUpperCase();
      const chips = [];
      if (isRound && h.is_hearts_and_arrows) chips.push('Hearts &amp; Arrows');
      if (!isRound && !isNaN(lw)) chips.push('L/W ' + lwText);
      if (certLabel(h)) chips.push(escHtml(certLabel(h)));
      if (polish === 'EX' && sym === 'EX') chips.push('Excellent Polish &amp; Symmetry');
      if (fl === 'N' || fl === 'NON' || fl === 'NONE') chips.push('No Fluorescence');
      const row = (dt, dd, note) => '<div><dt>' + dt + '</dt><dd>' + dd + (note ? '<span class="arelia-col__spec-note">' + note + '</span>' : '') + '</dd></div>';
      const grading = [];
      if (!isRound) grading.push(row('L/W Ratio', lwText, ratioGuide(shape, lw)));
      if (isRound) grading.push(row('Hearts &amp; Arrows', h.is_hearts_and_arrows ? 'Yes' : 'No'));
      grading.push(row('Polish', escHtml(gradeWord(h.polish) || '—')));
      grading.push(row('Symmetry', escHtml(gradeWord(h.symmetry) || '—')));
      grading.push(row('Fluorescence', escHtml(fluorWord(h.fluorescence) || '—')));
      const mm = h.size_mm ? escHtml(String(h.size_mm).toUpperCase().split('X').map(s => s.trim()).join(' × ')) + ' mm' : '—';
      const props = [row('Measurements', mm),
        row('Table', h.table_pct != null && h.table_pct !== '' ? escHtml(h.table_pct) + '%' : '—'),
        row('Depth', h.depth_pct != null && h.depth_pct !== '' ? escHtml(h.depth_pct) + '%' : '—')];
      if (isRound) props.push(row('L/W Ratio', lwText));
      return (chips.length ? '<ul class="arelia-col__detail-chips">' + chips.map(c => '<li>' + c + '</li>').join('') + '</ul>' : '')
        + '<div class="arelia-col__spec-groups">'
        + '<div><h4 class="arelia-col__spec-group">Grading</h4><dl class="arelia-col__spec-list">' + grading.join('') + '</dl></div>'
        + '<div><h4 class="arelia-col__spec-group">Proportions</h4><dl class="arelia-col__spec-list">' + props.join('') + '</dl></div>'
        + '</div>'
        + '<p class="arelia-col__detail-box">In the box: the diamond and its ' + escHtml(certLabel(h) || 'grading') + ' certificate.</p>';
    }

    function renderTableRow(h) {
      const shape = h.shape || '';
      const shapeLower = shape.toLowerCase();
      const cert = h.certificate_authority || '';
      const variantId = h.variant_id || '';
      const handle = h.handle || '';
      const detailParts = [detailSpecsHtml(h, shape)];
      return [
        '<tr class="arelia-col__row"',
        ' data-product-handle="' + escHtml(handle) + '"',
        ' data-sku="' + escHtml(h.sku || '') + '"',
        ' data-variant-id="' + escHtml(variantId) + '"',
        ' data-object-id="' + escHtml(h.objectID || '') + '"',
        ' data-title="' + escHtml(h.title || '') + '"',
        ' data-certificate-number="' + escHtml(h.certificate_number || '') + '"',
        ' data-certificate-url="' + escHtml(h.certificate_url || '') + '"',
        ' data-shape="' + escHtml(shape) + '"',
        ' data-carat="' + escHtml(h.carat) + '"',
        ' data-cut="' + escHtml(h.cut) + '"',
        ' data-color="' + escHtml(h.color) + '"',
        ' data-clarity="' + escHtml(h.clarity) + '"',
        ' data-price="' + escHtml(h.price) + '"',
        ' data-depth="' + escHtml(h.depth_pct) + '"',
        ' data-table="' + escHtml(h.table_pct) + '"',
        ' data-lw="' + escHtml(h.lw_ratio) + '"',
        ' data-cert="' + escHtml(cert || 'None') + '">',
        '<td class="arelia-col__cell arelia-col__cell--icon">',
        shapeLower ? '<img class="arelia-col__shape-icon" src="' + shapeIconBase() + shapeLower + '.png" alt="" width="32" height="32" loading="lazy">' : '',
        '</td>',
        // Hearts & Arrows tag on rounds (CEO 2026-10-01); never on other shapes.
        '<td class="arelia-col__cell arelia-col__cell--shape">' + escHtml(shape)
          + (Array.isArray(h.catalogs) && h.catalogs.indexOf('top_picks') >= 0 ? ' <span class="arelia-col__ha-tag">Top Pick</span>' : '')
          + (/8X$/.test(certLabel(h)) ? ' <span class="arelia-col__ha-tag arelia-col__8x-tag" title="GCAL 8X cut grade">8X</span>' : '')
          + (h.is_hearts_and_arrows && shape === 'Round' ? ' <span class="arelia-col__ha-tag" title="Hearts &amp; Arrows">H&amp;A</span>' : '')
          + '</td>',
        '<td class="arelia-col__cell">' + escHtml(h.carat) + '<span class="arelia-col__unit"> ct</span></td>',
        '<td class="arelia-col__cell">' + escHtml(h.cut) + '</td>',
        '<td class="arelia-col__cell">' + escHtml(h.color) + '</td>',
        '<td class="arelia-col__cell">' + escHtml(h.clarity) + '</td>',
        '<td class="arelia-col__cell">' + escHtml(certLabel(h)) + '</td>',
        '<td class="arelia-col__cell arelia-col__cell--price">' + priceCell(h) + '</td>',
        '<td class="arelia-col__cell arelia-col__cell--expand">',
        '<button type="button" class="arelia-col__expand-btn" aria-expanded="false" aria-label="Show diamond details">',
        '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" d="M4 6l4 4 4-4"/></svg>',
        '</button>',
        '</td>',
        '</tr>',
        '<tr class="arelia-col__detail-row" hidden>',
        '<td colspan="9" class="arelia-col__detail-cell">',
        '<div class="arelia-col__detail">',
        '<button type="button" class="arelia-col__detail-close" data-detail-close aria-label="Close diamond details">×</button>',
        '<div class="arelia-col__detail-media">',
        '<div class="arelia-col__detail-img">',
        // Media priority (mirrors the PDP): Cutwise 3D viewer if we have one,
        // else GCAL Vision360 (only some stones have it), else static image.
        (window.AreliaLoupe && window.AreliaLoupe.isLoupe(h.video_viewer_url))
          ? '<iframe class="arelia-col__detail-cutwise-iframe arelia-col__detail-loupe" data-loupe-src="' + escHtml(h.video_viewer_url) + '" data-loupe-playing="false" src="' + escHtml(window.AreliaLoupe.url(h.video_viewer_url, false)) + '" title="3D rotating view of ' + escHtml(h.title || '') + '" loading="lazy" referrerpolicy="no-referrer-when-downgrade" allow="fullscreen" scrolling="no" width="200" height="200"></iframe>'
          : (h.video_viewer_url)
          ? '<iframe class="arelia-col__detail-cutwise-iframe" src="' + escHtml(h.video_viewer_url) + '" title="3D rotating view of ' + escHtml(h.title || '') + '" loading="lazy" referrerpolicy="no-referrer-when-downgrade" allow="fullscreen" scrolling="no" width="200" height="200"></iframe>'
          : (h.vision_360_available && h.certificate_number)
            ? '<iframe class="arelia-col__detail-gcal-iframe" src="https://images.gemfacts.com/GCALimages/Certs/Vision360.html?d=' + escHtml(h.gcal_asset_id || h.certificate_number) + '&btn=1" title="GCAL Vision360 rotating view of ' + escHtml(h.title || '') + ', certificate ' + escHtml(h.certificate_number) + '" loading="lazy" referrerpolicy="no-referrer-when-downgrade" allow="fullscreen" scrolling="no" width="200" height="200"></iframe>'
            : (h.image_url ? '<img src="' + escHtml(h.image_url) + '" alt="' + escHtml(h.image_alt || h.title || '') + '" loading="lazy" width="200" height="200">'
                : (shapeLower ? '<img src="' + shapeIconBase() + shapeLower + '.png" alt="' + escHtml(shape) + ' cut lab-grown diamond" loading="lazy" width="200" height="200">' : '')),
        '</div>',
        // Mode-aware action area in the detail row:
        //   browse:       loose-stone "Add to Cart" form (POSTs /cart/add).
        //   ring-builder: "Add this diamond to my ring →" — selects + scrolls
        //     to the hero Add-to-Cart so the customer can review/compare.
        //   dar2-step1:   two buttons — "Use this stone for a ring →"
        //     (navigates to step 2 with the diamond in URL params) and
        //     "Buy this stone alone →" (POSTs single line-item to cart with
        //     `_build_flow=stone_alone` for telemetry). #118 wires this.
        (function () {
          const m = ((document.querySelector('.arelia-col') || {}).dataset || {}).mode;
          if (m === 'ring-builder') {
            return '<button type="button" class="arelia-col__add-cart arelia-col__add-cart--ring" data-add-to-ring="1">Add this diamond to my ring →</button>';
          }
          if (m === 'dar2-step1') {
            return [
              '<button type="button" class="arelia-col__add-cart arelia-col__add-cart--dar2-ring" data-dar2-action="use-for-ring">Use this stone for a ring →</button>',
              '<button type="button" class="arelia-col__add-cart arelia-col__add-cart--dar2-alone" data-dar2-action="stone-alone">Buy this stone alone →</button>',
            ].join('');
          }
          return variantId ? '<form action="/cart/add" method="post" class="arelia-col__cart-form"><input type="hidden" name="id" value="' + escHtml(variantId) + '"><input type="hidden" name="quantity" value="1">' + certPropertyInputs(cert, h.certificate_number, h.certificate_url) + '<button type="submit" class="arelia-col__add-cart" name="add">Add to Cart</button></form>' : '';
        })(),
        (window.AreliaLoupe && window.AreliaLoupe.isLoupe(h.video_viewer_url))
          ? '<p class="arelia-col__image-disclaimer">3D interactive view of the actual stone.</p><button type="button" class="arelia-col__spin-btn" data-loupe-toggle aria-pressed="false">Play</button>'
          : (h.video_viewer_url || (h.vision_360_available && h.certificate_number))
          ? '<p class="arelia-col__image-disclaimer">3D interactive view of the actual stone.</p>'
          : (cert === 'GCAL' && h.image_url
              ? '<p class="arelia-col__image-disclaimer">Photograph of the actual stone from its GCAL certificate.</p>'
              : '<p class="arelia-col__image-disclaimer">Diamond image is representative of the actual stone.</p>'),
        '</div>',
        '<div class="arelia-col__detail-specs">',
        '<h3 class="arelia-col__detail-title">' + escHtml(h.title || '') + '</h3>',
        detailParts.join(''),
        '<div class="arelia-col__detail-actions">',
        h.certificate_url ? '<a class="arelia-col__cert-link" href="' + escHtml(h.certificate_url) + '" target="_blank" rel="noopener">View ' + escHtml(certLabel(h) || cert) + ' certificate' + (h.certificate_number ? ' #' + escHtml(h.certificate_number) : '') + ' →</a>' : '',
        // View-full-details link only in browse mode — both ring-builder
        // and dar2-step1 modes are in-context flows where navigating to
        // the loose-stone PDP would break the experience.
        (function () {
          const m = ((document.querySelector('.arelia-col') || {}).dataset || {}).mode;
          if (m === 'ring-builder' || m === 'dar2-step1') return '';
          return '<a class="arelia-col__view-product" href="' + productHref(handle) + '">View full details →</a>';
        })(),
        '</div>',
        '<div class="arelia-col__detail-price">' + priceCell(h) + '</div>',
        '</div>',
        '</div>',
        '</td>',
        '</tr>',
      ].join('');
    }

    function renderGridCard(h) {
      const shape = h.shape || '';
      const shapeLower = shape.toLowerCase();
      const handle = h.handle || '';
      const variantId = h.variant_id || '';
      return [
        '<li class="arelia-col__card"',
        ' data-product-handle="' + escHtml(handle) + '"',
        ' data-sku="' + escHtml(h.sku || '') + '"',
        ' data-variant-id="' + escHtml(variantId) + '"',
        ' data-object-id="' + escHtml(h.objectID || '') + '"',
        ' data-title="' + escHtml(h.title || '') + '"',
        ' data-certificate-number="' + escHtml(h.certificate_number || '') + '"',
        ' data-certificate-url="' + escHtml(h.certificate_url || '') + '"',
        ' data-shape="' + escHtml(shape) + '"',
        ' data-carat="' + escHtml(h.carat) + '"',
        ' data-cut="' + escHtml(h.cut) + '"',
        ' data-color="' + escHtml(h.color) + '"',
        ' data-clarity="' + escHtml(h.clarity) + '"',
        ' data-price="' + escHtml(h.price) + '"',
        ' data-depth="' + escHtml(h.depth_pct) + '"',
        ' data-table="' + escHtml(h.table_pct) + '"',
        ' data-lw="' + escHtml(h.lw_ratio) + '"',
        ' data-cert="' + escHtml(h.certificate_authority || 'None') + '">',
        '<a href="' + productHref(handle) + '" class="arelia-col__card-link">',
        '<span class="arelia-col__card-image">',
        shapeLower ? '<img src="' + shapeIconBase() + shapeLower + '.png" alt="' + escHtml(shape) + ' cut lab-grown diamond" loading="lazy" width="180" height="180">' : '',
        '</span>',
        '<span class="arelia-col__card-specs">',
        // Same gold H&A tag as the table row (CEO 2026-10-01); rounds only.
        '<strong class="arelia-col__card-primary">' + escHtml(h.carat) + ' ct ' + escHtml(shape)
          + (Array.isArray(h.catalogs) && h.catalogs.indexOf('top_picks') >= 0 ? ' <span class="arelia-col__ha-tag">Top Pick</span>' : '')
          + (/8X$/.test(certLabel(h)) ? ' <span class="arelia-col__ha-tag arelia-col__8x-tag" title="GCAL 8X cut grade">8X</span>' : '')
          + (h.is_hearts_and_arrows && shape === 'Round' ? ' <span class="arelia-col__ha-tag" title="Hearts &amp; Arrows">H&amp;A</span>' : '')
          + '</strong>',
        // Spec line (mockup 2026-09-30): "Ideal" is on every stone, so show what
        // differs instead: the certificate grade (H&A is the gold tag in the title).
        '<span class="arelia-col__card-secondary">' + escHtml(h.color) + ' · ' + escHtml(h.clarity) + ' · ' +
          escHtml(certLabel(h) || 'GCAL') + '</span>',
        '</span>',
        '<span class="arelia-col__card-price">' + priceCell(h) + '</span>',
        '</a>',
        '</li>',
      ].join('');
    }

    // Body-scroll lock helper. On mobile the detail row is positioned as
    // a fixed-position modal (see arelia-diamond-picker.css media query);
    // the lock prevents the page underneath from scrolling.
    function syncDetailLock() {
      const anyOpen = !!document.querySelector('.arelia-col__detail-row:not([hidden])');
      document.body.classList.toggle('arelia-detail-modal-open', anyOpen);
    }
    function loupeFrame(detail) {
      return detail ? detail.querySelector('[data-loupe-src]') : null;
    }
    function stopLoupe(detail) {
      const frame = loupeFrame(detail);
      if (!frame || !window.AreliaLoupe) return;
      window.AreliaLoupe.setPlaying(frame, detail.querySelector('[data-loupe-toggle]'), false);
    }
    function pauseLoupesExcept(detail) {
      document.querySelectorAll('.arelia-col__detail-row').forEach(function (other) {
        if (other !== detail) stopLoupe(other);
      });
    }
    function playLoupe(detail) {
      pauseLoupesExcept(detail);
      const frame = loupeFrame(detail);
      if (!frame || !window.AreliaLoupe) return;
      window.AreliaLoupe.setPlaying(frame, detail.querySelector('[data-loupe-toggle]'), true);
    }
    function closeAnyOpenDetail() {
      const open = document.querySelector('.arelia-col__detail-row:not([hidden])');
      if (!open) return;
      stopLoupe(open);
      const row = open.previousElementSibling;
      open.hidden = true;
      if (row) {
        row.classList.remove('is-expanded');
        const btn = row.querySelector('.arelia-col__expand-btn');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
      syncDetailLock();
    }
    // Global ESC to dismiss the open detail/modal — no per-row binding.
    if (!document._areliaDetailEscBound) {
      document._areliaDetailEscBound = true;
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape') closeAnyOpenDetail();
      });
    }

    function bindRowExpands(root) {
      root.querySelectorAll('.arelia-col__row').forEach(row => {
        if (row._expandBound) return;
        row._expandBound = true;
        const detail = row.nextElementSibling;
        if (!detail || !detail.classList.contains('arelia-col__detail-row')) return;
        const btn = row.querySelector('.arelia-col__expand-btn');
        row.addEventListener('click', e => {
          if (e.target.closest('a')) return;
          if (e.target.closest('form')) return;
          if (e.target.closest('[data-detail-close]')) return;
          if (e.target.closest('button') && !e.target.closest('.arelia-col__expand-btn')) return;
          const opening = detail.hidden;
          detail.hidden = !opening;
          row.classList.toggle('is-expanded', opening);
          if (btn) btn.setAttribute('aria-expanded', opening ? 'true' : 'false');
          syncDetailLock();
          if (!opening) stopLoupe(detail);
          else if (window.AreliaLoupe && window.AreliaLoupe.reduced()) {
            pauseLoupesExcept(detail);
            stopLoupe(detail);
          } else playLoupe(detail);
        });
        const spinBtn = detail.querySelector('[data-loupe-toggle]');
        if (spinBtn && !spinBtn._bound) {
          spinBtn._bound = true;
          spinBtn.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
            const frame = loupeFrame(detail);
            if (!frame) return;
            if (frame.getAttribute('data-loupe-playing') === 'true') stopLoupe(detail);
            else playLoupe(detail);
          });
        }
        // Close button inside the detail panel (mobile-only modal × ).
        const closeBtn = detail.querySelector('[data-detail-close]');
        if (closeBtn && !closeBtn._bound) {
          closeBtn._bound = true;
          closeBtn.addEventListener('click', e => {
            e.stopPropagation();
            stopLoupe(detail);
            detail.hidden = true;
            row.classList.remove('is-expanded');
            if (btn) btn.setAttribute('aria-expanded', 'false');
            syncDetailLock();
          });
        }
      });
    }

    const PAGE_SIZE = 50;

    // Shape-first ordering now comes from Algolia (main index customRanking
    // asc(shape_rank), asc(price)) — see #188 / push_to_algolia.py. The old
    // client-side sortByShapePriority() was removed with the 1000-hit fetch.

    // Server-side pagination render (#188). Rebuilds the pagination nav from
    // the Algolia response's nbHits so it reflects the *filtered* total at any
    // catalog size — replacing the old SSR-frozen collection pagination + its
    // phantom-page-hiding glue. Windowed (first / last / current±2 with
    // ellipsis) so hundreds of pages stay compact. Markup mirrors Shopify's
    // default_pagination (span.pagination > span.page/prev/next) so the
    // existing CSS applies unchanged. Links carry full filter state via
    // buildUrl; clicks are handled by delegation in setupRoot.
    function renderPagination(root, data) {
      const nav = root.querySelector('.arelia-col__pagination');
      if (!nav) return;
      const total = data.nbHits || 0;
      const totalPages = Math.max(1, Math.ceil(total / PAGE_SIZE));
      const cur = Math.min(totalPages, Math.max(1, (data.page || 0) + 1));
      if (totalPages <= 1) { nav.innerHTML = ''; nav.hidden = true; return; }
      nav.hidden = false;

      // Windowed page set: 1, last, and cur±2; gaps become ellipsis decos.
      const want = new Set([1, totalPages]);
      for (let p = cur - 2; p <= cur + 2; p++) if (p >= 1 && p <= totalPages) want.add(p);
      const pages = Array.from(want).sort((a, b) => a - b);

      const parts = [];
      if (cur > 1) {
        parts.push('<span class="prev"><a href="' + escHtml(buildUrl({ page: cur - 1 })) +
                   '" data-page="' + (cur - 1) + '" rel="prev">&lsaquo; Prev</a></span>');
      }
      let prev = 0;
      for (const p of pages) {
        if (prev && p - prev > 1) parts.push('<span class="deco">&hellip;</span>');
        if (p === cur) {
          parts.push('<span class="page current">' + p + '</span>');
        } else {
          parts.push('<span class="page"><a href="' + escHtml(buildUrl({ page: p })) +
                     '" data-page="' + p + '">' + p + '</a></span>');
        }
        prev = p;
      }
      if (cur < totalPages) {
        parts.push('<span class="next"><a href="' + escHtml(buildUrl({ page: cur + 1 })) +
                   '" data-page="' + (cur + 1) + '" rel="next">Next &rsaquo;</a></span>');
      }
      nav.innerHTML = '<span class="pagination">' + parts.join('') + '</span>';
    }

    // Populate the Certificate dropdown with the distinct values that
    // actually appear in the current filtered result set, sorted by count
    // descending. Reads `data.facets.certificate_authority` from the
    // Algolia response. After replacing the option list, restores the
    // active selection from the URL (page-load case) or the prior value
    // (filter-change case), whichever is still a valid option.
    function populateCertOptions(root, data) {
      const sel = root.querySelector('[data-cert-select]');
      if (!sel) return;
      const facets = (data.facets && data.facets.certificate_authority) || {};
      const entries = Object.entries(facets)
        .filter(([k, v]) => k && v > 0)
        .sort((a, b) => b[1] - a[1]);
      const prevValue = sel.value;
      const urlValue = new URLSearchParams(window.location.search).get('certificate_authority') || '';
      const validKeys = new Set(entries.map(([k]) => k));
      const opts = ['<option value="">Any</option>'];
      for (const [val, count] of entries) {
        opts.push('<option value="' + escHtml(val) + '">' +
                  escHtml(val) + ' (' + count + ')</option>');
      }
      sel.innerHTML = opts.join('');
      // URL state wins (page load); else prior in-page selection; else Any.
      const desired = validKeys.has(urlValue) ? urlValue
                    : validKeys.has(prevValue) ? prevValue
                    : '';
      sel.value = desired;
    }

    function renderResults(root, data) {
      populateCertOptions(root, data);
      // Server-side pagination (#188): data.hits IS the current page (<=50),
      // already in shape-first (main index) or column-sort (replica) order
      // straight from Algolia. No client-side re-sort or slice.
      const hits = data.hits || [];
      const catalog = (currentFilterState().catalog) || 'top_picks';
      const emptyHtml = catalog === 'top_picks'
        ? 'No Top Picks match these filters. <button type="button" class="arelia-col__inline-reset" data-catalog-all>See more in All Diamonds</button>'
        : 'No diamonds match your filters. Try widening your criteria or <button type="button" class="arelia-col__inline-reset" data-reset>reset filters</button>.';
      const tbody = root.querySelector('.arelia-col__table tbody');
      if (tbody) {
        tbody.innerHTML = hits.length === 0
          ? '<tr><td colspan="9" class="arelia-col__empty">' + emptyHtml + '</td></tr>'
          : hits.map(renderTableRow).join('');
      }
      const grid = root.querySelector('.arelia-col__grid');
      if (grid) {
        grid.innerHTML = hits.map(renderGridCard).join('');
      }
      const count = root.querySelector('[data-result-count]');
      if (count) count.textContent = data.nbHits || 0;
      root.querySelectorAll('[data-no-results]').forEach(noResults => {
        noResults.hidden = hits.length > 0;
        if (hits.length === 0) noResults.innerHTML = emptyHtml;
      });
      root.querySelectorAll('[data-catalog-tab]').forEach(tab => {
        const on = tab.getAttribute('data-catalog-tab') === catalog;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      bindRowExpands(root);
      renderPagination(root, data);
    }

    let reqToken = 0;
    async function refreshSection(url, opts) {
      const pushState = !opts || opts.pushState !== false;
      const root = getRoot();
      if (!root) return;
      if (pushState) history.pushState({}, '', url);
      const state = currentFilterState();
      const query = stateToAlgoliaQuery(state);
      const indexName = indexForSort(state.sort);
      updateSortIndicators(root, state.sort);
      root.classList.add('is-loading');
      const my = ++reqToken;
      try {
        const resp = await fetch(ALGOLIA_HOST + '/1/indexes/' + indexName + '/query', {
          method: 'POST',
          headers: {
            'X-Algolia-API-Key': algoliaConfig().key,
            'X-Algolia-Application-Id': ALGOLIA_APP_ID,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(query),
        });
        if (my !== reqToken) return;
        const data = await resp.json();
        renderResults(root, data);
      } catch (e) {
        console.error('[arelia] Algolia query failed', e);
      } finally {
        const r = getRoot();
        if (r) r.classList.remove('is-loading');
      }
    }

    let debounceTimer = null;
    function debouncedRefresh(overrides, delay) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => refreshSection(buildUrl(overrides)), delay || 350);
    }

    // ============================ ROOT SETUP ============================
    function setupRoot(root) {
      if (!root) return;
      const state = currentFilterState();
      if (!root._catalogBound) {
        root._catalogBound = true;
        root.addEventListener('click', (e) => {
          const tab = e.target.closest('[data-catalog-tab]');
          const more = e.target.closest('[data-catalog-all]');
          if (!tab && !more) return;
          e.preventDefault();
          const catalog = more ? 'all' : tab.getAttribute('data-catalog-tab');
          refreshSection(buildUrl({ catalog: catalog, page: 1 }));
        });
      }

      // Ring-builder mode: hijack any click on a stone row/card and
      // dispatch `arelia:stone-selected` instead of letting the default
      // navigation/expand handlers fire. The host page (engagement-ring
      // builder) listens for the event and updates the price total +
      // selection state. No PDP navigation, no add-to-cart on individual
      // stones — the buyer is configuring a ring, not buying a loose stone.
      if (root.dataset.mode === 'ring-builder' && !root._stoneSelectBound) {
        root._stoneSelectBound = true;
        // Helper — build a hit payload from a stone row/card's data attributes.
        // Used both by the row click (select) and the "Add to my ring" button
        // in the detail row (force-select if not already selected).
        function buildHitFromEl(el) {
          const ds = el.dataset;
          return {
            objectID: ds.objectId || '',
            handle: ds.productHandle || '',
            title: ds.title || '',
            sku: ds.sku || '',
            variant_id: ds.variantId || '',
            shape: ds.shape || '',
            carat: ds.carat ? parseFloat(ds.carat) : null,
            cut: ds.cut || '',
            color: ds.color || '',
            clarity: ds.clarity || '',
            price: ds.price ? parseFloat(ds.price) : null,
            certificate_authority: ds.cert && ds.cert !== 'None' ? ds.cert : '',
            certificate_number: ds.certificateNumber || '',
            certificate_url: ds.certificateUrl || '',
            depth_pct: ds.depth ? parseFloat(ds.depth) : null,
            table_pct: ds.table ? parseFloat(ds.table) : null,
            lw_ratio: ds.lw ? parseFloat(ds.lw) : null,
          };
        }
        root.addEventListener('click', (e) => {
          // "Add this diamond to my ring →" button in the detail row.
          // Selects the stone (so the price total in the hero updates) and
          // scrolls the Total panel into view so the customer can review
          // before committing. Does NOT trigger Add-to-Cart — they pick
          // potentially several stones, compare totals, then click the
          // hero's Add-to-Cart when they're decided.
          const ringBtn = e.target.closest('.arelia-col__add-cart--ring');
          if (ringBtn) {
            e.preventDefault();
            e.stopPropagation();
            const detailRow = ringBtn.closest('.arelia-col__detail-row');
            const stoneRow = detailRow ? detailRow.previousElementSibling : null;
            if (stoneRow && !stoneRow.classList.contains('is-selected')) {
              root.querySelectorAll('.arelia-col__row.is-selected, .arelia-col__card.is-selected')
                  .forEach(el => el.classList.remove('is-selected'));
              stoneRow.classList.add('is-selected');
              document.dispatchEvent(new CustomEvent('arelia:stone-selected', {
                detail: { hit: buildHitFromEl(stoneRow), sourceEl: stoneRow },
              }));
            }
            // Scroll the Total/Add-to-Cart panel into view so the customer
            // sees the price update + decides whether to commit or compare.
            const totals = document.getElementById('erb-totals');
            if (totals) totals.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
          }

          // Skip clicks on internal interactive controls (filters/sort/
          // toggles/expand) — only stone-area clicks count as "select".
          if (e.target.closest('.arelia-col__sort-btn')) return;
          if (e.target.closest('.arelia-col__expand-btn')) return;
          if (e.target.closest('.arelia-col__filters')) return;
          if (e.target.closest('.arelia-col__toggles')) return;
          if (e.target.closest('.arelia-col__search-bar')) return;
          if (e.target.closest('.arelia-col__view-toggle')) return;
          if (e.target.closest('.arelia-col__detail-row')) return;  // detail buttons
          const stoneEl = e.target.closest('.arelia-col__row, .arelia-col__card');
          if (!stoneEl) return;
          if (!stoneEl.dataset.variantId) return;  // SSR rows without hydrated data
          e.preventDefault();
          e.stopPropagation();
          const ds = stoneEl.dataset;
          const hit = {
            objectID: ds.objectId || '',
            handle: ds.productHandle || '',
            title: ds.title || '',
            sku: ds.sku || '',
            variant_id: ds.variantId || '',
            shape: ds.shape || '',
            carat: ds.carat ? parseFloat(ds.carat) : null,
            cut: ds.cut || '',
            color: ds.color || '',
            clarity: ds.clarity || '',
            price: ds.price ? parseFloat(ds.price) : null,
            certificate_authority: ds.cert && ds.cert !== 'None' ? ds.cert : '',
            certificate_number: ds.certificateNumber || '',
            certificate_url: ds.certificateUrl || '',
            depth_pct: ds.depth ? parseFloat(ds.depth) : null,
            table_pct: ds.table ? parseFloat(ds.table) : null,
            lw_ratio: ds.lw ? parseFloat(ds.lw) : null,
          };
          // Visual feedback: mark this row/card as selected, clear the rest.
          root.querySelectorAll('.arelia-col__row.is-selected, .arelia-col__card.is-selected')
              .forEach(el => el.classList.remove('is-selected'));
          stoneEl.classList.add('is-selected');
          document.dispatchEvent(new CustomEvent('arelia:stone-selected', {
            detail: { hit, sourceEl: stoneEl },
          }));
        });
      }

      // Reset closures registered by every initRangeSlider call (headline
      // Price/Carat, ordinal Cut/Color/Clarity, advanced Depth/LW/Table).
      // refreshSection() never re-runs setupRoot, so the slider DOM persists
      // across "Reset filters" clicks unless we explicitly snap each handle
      // back to its config bounds.
      const rangeResetters = [];

      // ---- View toggle ----
      const defaultView = root.dataset.defaultView || 'table';
      let savedView;
      try { savedView = localStorage.getItem(STORAGE_VIEW_KEY); } catch (e) { savedView = null; }
      function setView(v) {
        root.querySelectorAll('.arelia-col__view-btn').forEach(btn => {
          const active = btn.dataset.view === v;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        root.querySelectorAll('.arelia-col__view').forEach(el => { el.hidden = el.dataset.view !== v; });
        // Grid has no column headers — show the sort dropdown there (#307).
        root.querySelectorAll('[data-sort-select-wrap]').forEach(el => { el.hidden = v !== 'grid'; });
        try { localStorage.setItem(STORAGE_VIEW_KEY, v); } catch (e) {}
      }
      root.querySelectorAll('.arelia-col__view-btn').forEach(btn => btn.addEventListener('click', () => setView(btn.dataset.view)));
      setView(savedView || defaultView);

      // ---- Row expand ----
      root.querySelectorAll('.arelia-col__row').forEach(row => {
        const detail = row.nextElementSibling;
        if (!detail || !detail.classList.contains('arelia-col__detail-row')) return;
        const btn = row.querySelector('.arelia-col__expand-btn');
        row.addEventListener('click', e => {
          if (e.target.closest('a')) return;
          if (e.target.closest('form')) return;
          if (e.target.closest('button') && !e.target.closest('.arelia-col__expand-btn')) return;
          const isOpen = !detail.hidden;
          detail.hidden = isOpen;
          row.classList.toggle('is-expanded', !isOpen);
          if (btn) btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        });
      });

      // ---- Shape filter ----
      const shapeBtns = root.querySelectorAll('.arelia-filter__shape-btn');
      const selectedShapes = new Set(state.shapes || []);
      function updateShapeValue() {
        const el = root.querySelector('.arelia-filter--shape [data-filter-value]');
        if (!el) return;
        el.textContent = selectedShapes.size === 0 ? 'All' : Array.from(selectedShapes).join(', ');
      }
      shapeBtns.forEach(btn => {
        const shape = btn.dataset.shape;
        btn.setAttribute('aria-pressed', selectedShapes.has(shape) ? 'true' : 'false');
        btn.addEventListener('click', async () => {
          if (selectedShapes.has(shape)) selectedShapes.delete(shape); else selectedShapes.add(shape);
          btn.setAttribute('aria-pressed', selectedShapes.has(shape) ? 'true' : 'false');
          updateShapeValue();
          await refreshSection(buildUrl({ shapes: Array.from(selectedShapes), page: 1 }));
        });
      });
      updateShapeValue();

      // ---- Range slider helper ----
      function initRangeSlider(filterEl, config) {
        const fill = filterEl.querySelector('.arelia-filter__track-fill');
        const valueEl = filterEl.querySelector('[data-filter-value]');
        const minInput = filterEl.querySelector('[data-handle="min"]');
        const maxInput = filterEl.querySelector('[data-handle="max"]');
        // Optional companion <input type="number"> boxes (Price + Carat use them).
        const minNum = filterEl.querySelector('[data-range-input="min"]');
        const maxNum = filterEl.querySelector('[data-range-input="max"]');
        const numFmt = config.numberFormatter || (v => String(v));
        // Boxes may show formatted text ("$10,533"); read the number back from the digits.
        const numParse = v => parseFloat(String(v).replace(/[^0-9.]/g, ''));
        // Grade sliders (#309 follow-up) keep the handles at least one segment
        // apart and map handle positions to grade ranks; price/carat use 0 + identity.
        const gap = config.minGap || 0;
        const toUrl = config.toUrl || ((lo, hi) => [lo, hi]);
        minInput.min = config.min; minInput.max = config.max; minInput.step = config.step;
        maxInput.min = config.min; maxInput.max = config.max; maxInput.step = config.step;
        const initMin = (config.initMin !== undefined) ? config.initMin : config.min;
        const initMax = (config.initMax !== undefined) ? config.initMax : config.max;
        minInput.value = initMin;
        maxInput.value = initMax;
        if (minNum) { minNum.min = config.min; minNum.max = config.max; minNum.step = config.step; minNum.value = numFmt(initMin); }
        if (maxNum) { maxNum.min = config.min; maxNum.max = config.max; maxNum.step = config.step; maxNum.value = numFmt(initMax); }

        function updateUI() {
          const range = config.max - config.min;
          const pctMin = range === 0 ? 0 : ((parseFloat(minInput.value) - config.min) / range) * 100;
          const pctMax = range === 0 ? 100 : ((parseFloat(maxInput.value) - config.min) / range) * 100;
          if (fill) {
            fill.style.left = 'calc(8px + ' + pctMin + '% - ' + (pctMin * 0.16) + 'px)';
            fill.style.right = 'calc(8px + ' + (100 - pctMax) + '% - ' + ((100 - pctMax) * 0.16) + 'px)';
          }
          if (valueEl) valueEl.textContent = config.formatter(parseFloat(minInput.value), parseFloat(maxInput.value));
          if (minNum && document.activeElement !== minNum) minNum.value = numFmt(parseFloat(minInput.value));
          if (maxNum && document.activeElement !== maxNum) maxNum.value = numFmt(parseFloat(maxInput.value));
          if (config.onUIUpdate) config.onUIUpdate(parseFloat(minInput.value), parseFloat(maxInput.value));
          // Each native <input type="range"> spans the full slider width.
          // Without a clip, whichever input has the higher z-index hides the
          // other input's thumb pseudo-element — only ONE thumb renders at a
          // time. Clip each input to its own half of the track (split at the
          // midpoint between the two values) so neither input visually covers
          // the other's thumb. Both handles then render as full circles
          // simultaneously regardless of position. Diagnosed 2026-05-06,
          // see incident 2026-05-06-diamond-picker-slider-thumb-clipping.md.
          const mid = (pctMin + pctMax) / 2;
          minInput.style.clipPath = 'inset(0 calc(100% - ' + mid + '%) 0 0)';
          maxInput.style.clipPath = 'inset(0 0 0 ' + mid + '%)';
        }
        function applyAndRefresh() {
          let lo = parseFloat(minInput.value), hi = parseFloat(maxInput.value);
          if (lo > hi - gap) { lo = hi - gap; minInput.value = lo; }
          updateUI();
          const overrides = { page: 1 };
          const urlVals = toUrl(lo, hi);
          overrides[config.urlGteKey] = urlVals[0];
          overrides[config.urlLteKey] = urlVals[1];
          debouncedRefresh(overrides, 400);
        }
        minInput.addEventListener('input', () => {
          if (parseFloat(minInput.value) > parseFloat(maxInput.value) - gap) minInput.value = parseFloat(maxInput.value) - gap;
          applyAndRefresh();
        });
        maxInput.addEventListener('input', () => {
          if (parseFloat(maxInput.value) < parseFloat(minInput.value) + gap) maxInput.value = parseFloat(minInput.value) + gap;
          applyAndRefresh();
        });

        // Number-input ↔ slider sync. Apply on Enter or blur (matches the
        // popover behavior); typed values are clamped to the slider bounds
        // and forced into [min, max] order before the Algolia call fires.
        function syncFromNumber(numEl, rangeEl, isMin) {
          let v = numParse(numEl.value);
          if (isNaN(v)) v = parseFloat(rangeEl.value);
          v = Math.max(config.min, Math.min(v, config.max));
          if (isMin && v > parseFloat(maxInput.value)) v = parseFloat(maxInput.value);
          if (!isMin && v < parseFloat(minInput.value)) v = parseFloat(minInput.value);
          numEl.value = numFmt(v);
          rangeEl.value = v;
          applyAndRefresh();
        }
        // Currency boxes: show plain digits while editing, formatted otherwise.
        [minNum, maxNum].forEach(el => {
          if (!el || !(el.hasAttribute('data-currency') || el.hasAttribute('data-formatted'))) return;
          el.addEventListener('focus', () => { const v = numParse(el.value); el.value = isNaN(v) ? '' : (el.hasAttribute('data-currency') ? String(Math.round(v)) : String(v)); el.select(); });
          el.addEventListener('blur', () => { const v = numParse(el.value); if (!isNaN(v)) el.value = numFmt(v); });
        });
        if (minNum) {
          minNum.addEventListener('change', () => syncFromNumber(minNum, minInput, true));
          minNum.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); minNum.blur(); } });
        }
        if (maxNum) {
          maxNum.addEventListener('change', () => syncFromNumber(maxNum, maxInput, false));
          maxNum.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); maxNum.blur(); } });
        }

        // SLIDER-STUCK-FIX-V2 — Click-on-track-to-jump-near-handle. Standard slider escape hatch
        // when both thumbs converge — clicking left of the stack pulls min
        // back, clicking right pushes max forward. Filters out clicks on
        // the thumb itself (those are drag interactions handled natively).
        const slider = filterEl.querySelector('[data-slider]');
        if (slider) {
          slider.addEventListener('click', (e) => {
            if (e.target.classList && e.target.classList.contains('arelia-filter__thumb')) return;
            const rect = slider.getBoundingClientRect();
            const pad = 8;  // matches CSS padding-inline on the slider
            const usable = rect.width - 2 * pad;
            if (usable <= 0) return;
            const x = Math.max(0, Math.min(e.clientX - rect.left - pad, usable));
            const pct = x / usable;
            const raw = config.min + pct * (config.max - config.min);
            const snapped = Math.round(raw / config.step) * config.step;
            const lo = parseFloat(minInput.value);
            const hi = parseFloat(maxInput.value);
            const distLo = Math.abs(snapped - lo);
            const distHi = Math.abs(snapped - hi);
            // When handles are stacked, side of the click decides which moves.
            const moveMin = distLo < distHi || (distLo === distHi && snapped < lo);
            if (minInput.disabled) return;
            if (moveMin) {
              minInput.value = Math.max(config.min, Math.min(snapped, hi - gap));
            } else {
              maxInput.value = Math.min(config.max, Math.max(snapped, lo + gap));
            }
            applyAndRefresh();
          });
        }

        rangeResetters.push(() => {
          minInput.value = config.min;
          maxInput.value = config.max;
          if (minNum) minNum.value = numFmt(config.min);
          if (maxNum) maxNum.value = numFmt(config.max);
          updateUI();
        });

        updateUI();
        if (config.onUIUpdate) config.onUIUpdate(initMin, initMax);
      }

      // Grade sliders (Cut / Color / Clarity), Blue Nile-style: each in-stock
      // grade is a SEGMENT of the track with its label centred above it, and
      // the two handles sit on segment boundaries. With N grades there are
      // N+1 boundary positions (0..N); the handles stay at least one segment
      // apart, so at least one grade is always selected. Handle positions map
      // to ranks: gte = min + lo, lte = min + hi - 1. A single in-stock grade
      // (Cut is all Ideal today) shows one full segment with locked handles.
      // Grayed, not-stocked grades to the left of a grade slider. The scale and
      // slider move into a 2x2 grid (gray labels | live labels, gray track |
      // live slider) whose columns are sized by grade count, so every grade gets
      // the same width. Rebuilt each init; removed if nothing is below stock.
      function buildGrayLead(filterEl, key, bounds, n, scaleEl, sliderEl) {
        if (!scaleEl || !sliderEl) return;
        const gray = (GRAYED[key] || []).filter(l => bounds.labels.indexOf(l) + 1 < bounds.min);
        let grid = filterEl.querySelector('.arelia-filter__grades');
        if (!gray.length) {
          if (grid) { grid.parentNode.insertBefore(scaleEl, grid); grid.parentNode.insertBefore(sliderEl, grid); grid.remove(); }
          return;
        }
        if (!grid) {
          grid = document.createElement('div');
          grid.className = 'arelia-filter__grades';
          scaleEl.parentNode.insertBefore(grid, scaleEl);
        }
        grid.querySelectorAll('.arelia-filter__lead').forEach(el => el.remove());
        grid.style.gridTemplateColumns = gray.length + 'fr ' + n + 'fr';
        const leadScale = document.createElement('div');
        leadScale.className = 'arelia-filter__lead arelia-filter__lead-scale';
        leadScale.innerHTML = gray.map((l, i) => '<span style="left:' + ((i + 0.5) / gray.length) * 100 + '%">' + l + '</span>').join('');
        const leadTrack = document.createElement('div');
        leadTrack.className = 'arelia-filter__lead arelia-filter__lead-track';
        leadTrack.innerHTML = gray.map(() => '<i></i>').join('');
        [leadScale, leadTrack].forEach(el => {
          el.title = GRAY_NOTE[key] || '';
          el.addEventListener('click', () => showGrayNote(filterEl, GRAY_NOTE[key]));
        });
        grid.append(leadScale, scaleEl, leadTrack, sliderEl);
      }
      function showGrayNote(filterEl, text) {
        if (!text) return;
        let note = filterEl.querySelector('.arelia-filter__gray-note');
        if (!note) {
          note = document.createElement('p');
          note.className = 'arelia-filter__gray-note';
          note.setAttribute('role', 'status');
          filterEl.appendChild(note);
        }
        note.textContent = text;
        note.hidden = false;
        clearTimeout(note._t);
        note._t = setTimeout(() => { note.hidden = true; }, 3500);
      }

      function initOrdinalSlider(filterEl, boundsKey, stateKey) {
        const bounds = BOUNDS[boundsKey];
        const labels = bounds.labels;          // full scale; label for rank r is labels[r - 1]
        const n = bounds.max - bounds.min + 1; // in-stock grades = segments
        const single = n === 1;
        const scaleEl = filterEl.querySelector('[data-scale]');
        const sliderEl = filterEl.querySelector('[data-slider]');
        const midPct = i => ((i + 0.5) / n) * 100;
        if (scaleEl) {
          scaleEl.innerHTML = labels.slice(bounds.min - 1, bounds.max)
            .map((l, i) => '<span style="left:' + midPct(i) + '%">' + l + '</span>').join('');
          if (sliderEl && scaleEl.parentNode === sliderEl.parentNode && scaleEl.nextElementSibling !== sliderEl) sliderEl.parentNode.insertBefore(scaleEl, sliderEl);
        }
        buildGrayLead(filterEl, boundsKey, bounds, n, scaleEl, sliderEl);
        // One track segment per grade, dark when selected. Rebuilt each init
        // (bounds follow live inventory).
        let segs = [];
        if (sliderEl) {
          sliderEl.querySelectorAll('.arelia-filter__seg').forEach(el => el.remove());
          for (let i = 0; i < n; i++) {
            const seg = document.createElement('div');
            seg.className = 'arelia-filter__seg';
            seg.style.left = 'calc(8px + (100% - 16px) * ' + (i / n) + ' + 1.5px)';
            seg.style.width = 'calc((100% - 16px) / ' + n + ' - 3px)';
            sliderEl.insertBefore(seg, sliderEl.querySelector('.arelia-filter__thumb'));
            segs.push(seg);
          }
        }
        // URL ranks -> handle positions, clamped (old links may ask for grades
        // no longer stocked, or for a collapsed lo > hi range).
        const clampRank = v => Math.max(bounds.min, Math.min(bounds.max, v));
        const gteRank = state[stateKey + '_gte'] === undefined ? bounds.min : clampRank(state[stateKey + '_gte']);
        const lteRank = state[stateKey + '_lte'] === undefined ? bounds.max : Math.max(gteRank, clampRank(state[stateKey + '_lte']));
        filterEl.classList.toggle('is-single-grade', single);
        filterEl.querySelectorAll('[data-handle]').forEach(h => { h.disabled = single; });
        initRangeSlider(filterEl, {
          min: 0, max: n, step: 1, minGap: 1,
          initMin: gteRank - bounds.min,
          initMax: lteRank - bounds.min + 1,
          urlGteKey: stateKey + '_gte',
          urlLteKey: stateKey + '_lte',
          toUrl: (lo, hi) => [bounds.min + lo, bounds.min + hi - 1],
          formatter: (lo, hi) => {
            if (single) return 'All ' + labels[bounds.min - 1];
            if (lo === 0 && hi === n) return 'Any';
            const a = labels[bounds.min + lo - 1], b = labels[bounds.min + hi - 2];
            return hi - lo === 1 ? a : a + ' → ' + b;
          },
          onUIUpdate: (lo, hi) => {
            segs.forEach((seg, i) => seg.classList.toggle('is-active', i >= lo && i < hi));
            if (!scaleEl) return;
            Array.from(scaleEl.children).forEach((span, i) => span.classList.toggle('is-active', i >= lo && i < hi));
          },
        });
      }

      initRangeSlider(root.querySelector('[data-filter="price"]'), {
        min: BOUNDS.price.min, max: BOUNDS.price.max, step: 1,
        initMin: state.price_gte, initMax: state.price_lte,
        urlGteKey: 'price_gte', urlLteKey: 'price_lte',
        formatter: (lo, hi) => '$' + Math.round(lo).toLocaleString() + ' – $' + Math.round(hi).toLocaleString(),
        numberFormatter: v => '$' + Math.round(v).toLocaleString('en-US'),  // "$10,533"; digits-only while focused
      });
      initRangeSlider(root.querySelector('[data-filter="carat"]'), {
        min: BOUNDS.carat.min, max: BOUNDS.carat.max, step: 0.01,
        initMin: state.carat_gte, initMax: state.carat_lte,
        urlGteKey: 'carat_gte', urlLteKey: 'carat_lte',
        formatter: (lo, hi) => lo.toFixed(2) + ' ct – ' + hi.toFixed(2) + ' ct',
        numberFormatter: v => v.toFixed(2),  // 0.05 → "0.05", 1.5 → "1.50"
      });
      initOrdinalSlider(root.querySelector('[data-filter="cut"]'),     'cut',     'cut_rank');
      initOrdinalSlider(root.querySelector('[data-filter="color"]'),   'color',   'color_rank');
      initOrdinalSlider(root.querySelector('[data-filter="clarity"]'), 'clarity', 'clarity_rank');

      // ---- Advanced filters panel (depth / table / L-W + certificate) ----
      // CEO 2026-10-01: the four advanced filters live in a collapsible panel
      // under "Advanced filters +", using the same inline slider + min/max boxes
      // as Price/Carat (they used to be pop-up pills). The button shows how many
      // advanced filters are active; the panel opens on load if any are.
      const advPanel = root.querySelector('[data-adv-panel]');
      const advToggle = root.querySelector('[data-adv-panel-toggle]');
      const advCountEl = root.querySelector('[data-adv-count]');
      const ADV = [
        { key: 'depth', bounds: BOUNDS.depth, gte: 'depth_pct_gte', lte: 'depth_pct_lte', fmt: v => v.toFixed(1) + '%' },
        { key: 'table', bounds: BOUNDS.table, gte: 'table_pct_gte', lte: 'table_pct_lte', fmt: v => v.toFixed(1) + '%' },
        { key: 'lw',    bounds: BOUNDS.lw,    gte: 'lw_ratio_gte',  lte: 'lw_ratio_lte',  fmt: v => v.toFixed(2) },
      ];
      function advActiveCount() {
        let n = 0;
        ADV.forEach(a => {
          const el = root.querySelector('[data-adv="' + a.key + '"]');
          if (!el) return;
          const lo = parseFloat(el.querySelector('[data-handle="min"]').value);
          const hi = parseFloat(el.querySelector('[data-handle="max"]').value);
          if (Math.abs(lo - a.bounds.min) > 1e-6 || Math.abs(hi - a.bounds.max) > 1e-6) n++;
        });
        const cert = root.querySelector('[data-cert-select]');
        if (cert && cert.value) n++;
        return n;
      }
      function updateAdvCount() {
        if (!advCountEl) return;
        const n = advActiveCount();
        advCountEl.hidden = n === 0;
        advCountEl.textContent = n ? ' (' + n + ')' : '';
      }
      function setAdvOpen(open) {
        if (!advPanel || !advToggle) return;
        advPanel.hidden = !open;
        advToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        const icon = advToggle.querySelector('.arelia-col__adv-icon');
        if (icon) icon.textContent = open ? '–' : '+';
      }
      ADV.forEach(a => {
        const el = root.querySelector('[data-adv="' + a.key + '"]');
        if (!el) return;
        initRangeSlider(el, {
          min: a.bounds.min, max: a.bounds.max, step: 0.01,
          initMin: state[a.gte], initMax: state[a.lte],
          urlGteKey: a.gte, urlLteKey: a.lte,
          formatter: (lo, hi) => a.fmt(lo) + ' – ' + a.fmt(hi),
          numberFormatter: a.fmt,
          onUIUpdate: () => updateAdvCount(),
        });
      });
      if (advToggle && !advToggle._bound) {
        advToggle._bound = true;
        advToggle.addEventListener('click', () => setAdvOpen(advPanel.hidden));
      }
      const certSel = root.querySelector('[data-cert-select]');
      if (certSel) certSel.addEventListener('change', updateAdvCount);
      updateAdvCount();
      if (advActiveCount() > 0 || state.certificate_authority) setAdvOpen(true);

      // ---- Sortable column headers (ref #40) ----
      // Each <th data-sort-th="<axis>"> wraps a <button data-sort-axis="<axis>">.
      // Click cycles default → asc → desc → default. State stored as `?sort=<axis>_<dir>`.
      // Visual indicator (filled triangle) reflects the active axis + direction.
      updateSortIndicators(root, state.sort);
      root.querySelectorAll('[data-sort-axis]').forEach(btn => {
        btn.addEventListener('click', async () => {
          const axis = btn.getAttribute('data-sort-axis');
          const cur = currentFilterState();
          const next = nextSortState(cur.sort, axis);
          await refreshSection(buildUrl({ sort: next || undefined, page: 1 }));
          // A column sort replaces any "Best value" preset — keep the pill in sync.
          if (typeof syncSortPresetVisuals === 'function') syncSortPresetVisuals();
        });
      });

      // Initial-load hydration is handled unconditionally after setupRoot (see
      // the fetchCatalogBounds().finally() call at the bottom) — it always
      // fires an Algolia query so first paint is shape-first + server-paginated
      // regardless of sort. No per-sort refresh needed here (#188).

      // ---- Search input: exact cert/SKU lookup OR describe-a-stone ----
      const searchInput = root.querySelector('[data-search]');
      const searchNote = root.querySelector('[data-search-note]');
      function showSearchNote(html) {
        if (!searchNote) return;
        searchNote.innerHTML = html;
        searchNote.hidden = !html;
      }
      if (searchInput) {
        searchInput.value = state.q || '';
        // Placeholder: certificate first (never cut off), then the example.
        // Use the long text only when it fits the box as rendered; re-check on
        // resize (the box is ~256px on small laptops, ~426px on wide screens).
        const longPh = searchInput.getAttribute('placeholder');
        const shortPh = searchInput.dataset.placeholderShort || longPh;
        function fitPlaceholder() {
          try {
            const cs = getComputedStyle(searchInput);
            const ctx = document.createElement('canvas').getContext('2d');
            ctx.font = cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
            searchInput.placeholder = ctx.measureText(longPh).width <= searchInput.clientWidth - 4 ? longPh : shortPh;
          } catch (e) { searchInput.placeholder = shortPh; }
        }
        fitPlaceholder();
        let phTimer = null;
        window.addEventListener('resize', () => { clearTimeout(phTimer); phTimer = setTimeout(fitPlaceholder, 150); });
        // Arrived from a retired stone's URL: the 404 page (sections/main-404.liquid)
        // sends /products/gdc-<cert> here with ?sold=1.
        if (new URLSearchParams(window.location.search).get('sold') === '1') {
          const sh = (state.shapes || [])[0];
          const lo = state.carat_gte, hi = state.carat_lte;
          let what = sh ? sh.toLowerCase() + ' diamonds' : 'diamonds';
          if (lo != null && hi != null) what += ' from ' + lo.toFixed(2) + ' to ' + hi.toFixed(2) + ' ct';
          showSearchNote(sh || lo != null
            ? 'The diamond you were looking for has sold. Here are similar <strong>' + what + '</strong> in stock now.'
            : 'The diamond you were looking for has sold. Every diamond below is in stock and ready to ship.');
        }
        // Note carried across the reload after a described search.
        try {
          const saved = sessionStorage.getItem(NL_NOTE_KEY);
          if (saved) { showSearchNote(saved); sessionStorage.removeItem(NL_NOTE_KEY); }
        } catch (e) {}
        let searchTimer = null;
        function runIdentifier() {
          const v = searchInput.value.trim();
          refreshSection(buildUrl({ q: v || undefined, page: 1 }));
        }
        function runDescribed() {
          const raw = searchInput.value.trim();
          const p = parseStoneQuery(raw);
          const esc = t => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
          if (!p.understood.length) {
            showSearchNote('Try a shape, carat, color, clarity or price — e.g. <em>2 carat oval under $3,000</em>, or a certificate number.');
            return;
          }
          // A described search starts fresh: only what was asked for is applied.
          const fresh = { shapes: p.shapes, q: undefined, page: 1, sort: '' };
          ['price', 'carat', 'color_rank', 'clarity_rank', 'cut_rank', 'depth_pct', 'table_pct', 'lw_ratio'].forEach(k => {
            fresh[k + '_gte'] = p[k + '_gte'] != null ? p[k + '_gte'] : undefined;
            fresh[k + '_lte'] = p[k + '_lte'] != null ? p[k + '_lte'] : undefined;
          });
          BOOLEAN_FILTERS.forEach(k => { fresh[k] = !!p[k]; });
          DROPDOWN_FILTERS.forEach(k => { fresh[k] = undefined; });
          let note = 'Showing <strong>' + esc(p.understood.join(' · ')) + '</strong> for “' + esc(raw) + '”.';
          if (p.ignored.length) note += ' <span class="arelia-col__search-note-muted">Not used: ' + esc(p.ignored.join(', ')) + '.</span>';
          try { sessionStorage.setItem(NL_NOTE_KEY, note); } catch (e) {}
          // Full navigation so every control (tiles, sliders, boxes, toggles)
          // re-initialises from the URL and visibly reflects the request.
          const url = new URL(buildUrl(fresh), window.location.origin);
          const keep = new URLSearchParams(window.location.search);
          ['preview_theme_id', '_ab', '_fd', '_sc', 'view'].forEach(k => { if (keep.get(k)) url.searchParams.set(k, keep.get(k)); });
          url.hash = 'arelia-results';
          window.location.assign(url.toString());
        }
        searchInput.addEventListener('input', () => {
          clearTimeout(searchTimer);
          const v = searchInput.value.trim();
          // Identifiers search live; descriptions wait for Enter (partial words
          // would flicker the results). Clearing the box clears the lookup.
          if (!v || isIdentifierQuery(v)) {
            showSearchNote('');
            searchTimer = setTimeout(runIdentifier, 250);
          }
        });
        searchInput.addEventListener('keydown', (e) => {
          if (e.key !== 'Enter') return;
          e.preventDefault();
          clearTimeout(searchTimer);
          const v = searchInput.value.trim();
          if (!v || isIdentifierQuery(v)) runIdentifier(); else runDescribed();
        });
        // Arrived from the header search (#410, assets/arelia-diamond-search.js):
        // ?find=<text> runs as if typed here. Drop it from the URL first so the
        // described search's reload doesn't run it again.
        const findText = new URLSearchParams(window.location.search).get('find');
        if (findText) {
          const clean = new URL(window.location.href);
          clean.searchParams.delete('find');
          history.replaceState(history.state, '', clean.toString());
          searchInput.value = findText;
          if (isIdentifierQuery(findText)) runIdentifier(); else runDescribed();
        }
        // After a described search, land on the results, not the page top.
        if (window.location.hash === '#arelia-results') {
          const target = root.querySelector('.arelia-col__search-bar') || root;
          setTimeout(() => target.scrollIntoView({ block: 'start' }), 60);
        }
      }

      // ---- Boolean toggle pills (Express / Overnight / On Sale) ----
      // Read state fresh on every click — the `state` closure variable above
      // is a snapshot from setupRoot's first run; clicking the pill changes
      // the URL via pushState but doesn't re-run setupRoot, so the closure
      // would otherwise stay stale and a second click wouldn't toggle off.
      function syncToggleVisuals() {
        const cur = currentFilterState();
        root.querySelectorAll('[data-toggle-filter]').forEach(b => {
          const k = b.dataset.toggleFilter;
          const on = !!cur[k];
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      function syncDropdownVisuals() {
        const cur = currentFilterState();
        root.querySelectorAll('[data-dropdown-filter]').forEach(label => {
          const k = label.dataset.dropdownFilter;
          const sel = label.querySelector('select');
          if (sel) sel.value = cur[k] || '';
        });
        updateAdvCount();
      }
      // "Best value" (and any future) sort-preset pill: active when the current
      // ?sort matches the pill's preset. Kept in sync after preset clicks AND
      // column-header sorts (which override the preset). (#198)
      function syncSortPresetVisuals() {
        const cur = currentFilterState();
        root.querySelectorAll('[data-sort-preset]').forEach(b => {
          const on = cur.sort === b.dataset.sortPreset;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        // Grid sort dropdown (#307): show the current sort; a table-only sort
        // (e.g. clarity) has no option, so the select shows blank.
        root.querySelectorAll('[data-sort-select]').forEach(sel => {
          const v = cur.sort || '';
          sel.value = Array.from(sel.options).some(o => o.value === v) ? v : '';
          if (sel.value !== v) sel.selectedIndex = -1;
        });
      }
      // Hearts & Arrows is an ordinary, always-visible filter (CEO 2026-09-30,
      // #309): it matches is_hearts_and_arrows:true, which today is exactly the
      // H&A rounds. The old round-only visibility gate never took effect (pill
      // CSS display overrode [hidden]) but did silently clear an active H&A
      // filter on reload/shape change; both removed.
      syncToggleVisuals();
      syncDropdownVisuals();
      syncSortPresetVisuals();

      root.querySelectorAll('[data-toggle-filter]').forEach(btn => {
        const key = btn.dataset.toggleFilter;
        btn.addEventListener('click', async () => {
          const cur = currentFilterState();
          const overrides = { page: 1 };
          overrides[key] = cur[key] ? undefined : true;  // toggle on↔off
          await refreshSection(buildUrl(overrides));
          syncToggleVisuals();
        });
      });

      // ---- Grid sort dropdown (#307) ----
      root.querySelectorAll('[data-sort-select]').forEach(sel => {
        sel.addEventListener('change', async () => {
          await refreshSection(buildUrl({ sort: sel.value || undefined, page: 1 }));
          syncSortPresetVisuals();
        });
      });

      // ---- Sort-preset pills ("Best value") ----
      root.querySelectorAll('[data-sort-preset]').forEach(btn => {
        const preset = btn.dataset.sortPreset;
        btn.addEventListener('click', async () => {
          const cur = currentFilterState();
          const next = cur.sort === preset ? undefined : preset;  // toggle on↔off
          await refreshSection(buildUrl({ sort: next, page: 1 }));
          syncSortPresetVisuals();
        });
      });

      // ---- Categorical dropdowns (Method / Certificate) ----
      root.querySelectorAll('[data-dropdown-filter]').forEach(label => {
        const key = label.dataset.dropdownFilter;
        const sel = label.querySelector('select');
        if (!sel) return;
        sel.addEventListener('change', async () => {
          const overrides = { page: 1 };
          overrides[key] = sel.value || undefined;
          await refreshSection(buildUrl(overrides));
          syncToggleVisuals();
          syncDropdownVisuals();
        });
      });

      // ---- Reset filters ----
      // refreshSection() only re-renders the table/grid — it does NOT
      // re-run setupRoot, so the slider DOM and shape buttons keep their
      // previous visual state unless we explicitly reset them here.
      root.querySelectorAll('[data-reset]').forEach(btn => {
        btn.addEventListener('click', async () => {
          selectedShapes.clear();
          shapeBtns.forEach(b => b.setAttribute('aria-pressed', 'false'));
          updateShapeValue();
          if (searchInput) searchInput.value = '';
          const sn = root.querySelector('[data-search-note]'); if (sn) { sn.hidden = true; sn.innerHTML = ''; }
          rangeResetters.forEach(fn => fn());
          await refreshSection(window.location.pathname);
          syncToggleVisuals();
          syncDropdownVisuals();
          syncSortPresetVisuals();
        });
      });

      // ---- Pagination links → AJAX (event delegation, #188) ----
      // renderPagination() rebuilds the nav's innerHTML on every result render,
      // so per-link bindings would go stale. Delegate on root instead: one
      // handler, bound once, matches whatever links currently exist.
      if (!root._paginationBound) {
        root._paginationBound = true;
        root.addEventListener('click', e => {
          const a = e.target.closest('.arelia-col__pagination a[href]');
          if (!a || !root.contains(a)) return;
          e.preventDefault();
          refreshSection(a.getAttribute('href'));
          const top = root.getBoundingClientRect().top + window.scrollY - 40;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        });
      }

      setupPhoneFilterSheet(root);
    }

    // ---- Phone filter panel (CEO 2026-10-01) ----
    // Below 750px, move every filter except Shape (and the Sale pill, which goes
    // to the bar) into a full-screen panel opened by "Filters (n)". Nodes are
    // moved, not cloned, so their listeners keep working; a placeholder comment
    // marks each original spot so they move back when the window widens.
    function setupPhoneFilterSheet(root) {
      if (root._mSheetBound) return;
      const sheet = root.querySelector('[data-m-sheet]');
      const body = root.querySelector('[data-m-sheet-body]');
      const bar = root.querySelector('[data-m-bar]');
      const saleSlot = root.querySelector('[data-m-sale-slot]');
      if (!sheet || !body || !bar) return;
      root._mSheetBound = true;
      const mq = window.matchMedia('(max-width: 749px)');
      const pick = sel => root.querySelector(sel);
      // [node, destination] in display order inside the panel.
      const moves = () => [
        // The search box stays on the page above Filters (CEO 2026-11-04).
        [pick('[data-filter="price"]'), body],
        [pick('[data-filter="carat"]'), body],
        [pick('[data-filter="cut"]'), body],
        [pick('[data-filter="color"]'), body],
        [pick('[data-filter="clarity"]'), body],
        [pick('[data-ha-toggle]'), body],
        [pick('[data-adv-panel-toggle]'), body],
        [pick('[data-adv-panel]'), body],
        [pick('[data-toggle-filter="is_deal"]'), saleSlot],
        // Compact phone top (CEO 2026-10-14 mockup): Table/Grid, count and sort join
        // the Filters row, so stones and prices show on the first screen. Table/Grid
        // sits next to Filters so shoppers can switch views without opening the
        // panel (CEO 2026-11-03, #394). Reset is in the panel footer; the page Reset
        // is hidden by CSS.
        [pick('.arelia-col__search-bar .arelia-col__view-toggle'), saleSlot],
        [pick('.arelia-col__search-bar .arelia-col__count-inline'), saleSlot],
        [pick('[data-sort-select-wrap]'), saleSlot],
      ].filter(m => m[0]);
      let moved = [];
      function toPhone() {
        if (moved.length) return;
        moves().forEach(([node, dest]) => {
          const mark = document.createComment('m-sheet');
          node.parentNode.insertBefore(mark, node);
          dest.appendChild(node);
          moved.push([node, mark]);
        });
        root.classList.add('is-phone-filters');
      }
      function toDesktop() {
        closeSheet();
        moved.forEach(([node, mark]) => { mark.parentNode.insertBefore(node, mark); mark.remove(); });
        moved = [];
        root.classList.remove('is-phone-filters');
      }
      const countEl = root.querySelector('[data-m-filter-count]');
      const showEl = root.querySelector('[data-m-show-count]');
      const resultEl = root.querySelector('[data-result-count]');
      // Active filters inside the panel (Shape and Sale are visible on the page).
      function activeInPanel() {
        const pr = new URLSearchParams(window.location.search);
        const groups = new Set();
        pr.forEach((v, k) => {
          const m = k.match(/^filter\.v\.(?:m\.custom\.)?([a-z_]+?)(?:_rank)?\.(?:gte|lte)$/) || k.match(/^filter\.v\.(price)\.(?:gte|lte)$/);
          if (m) groups.add(m[1]);
        });
        if (pr.get('is_hearts_and_arrows') === '1') groups.add('ha');
        if (pr.get('certificate_authority')) groups.add('cert');
        return groups.size;
      }
      function syncCounts() {
        const n = activeInPanel();
        if (countEl) { countEl.hidden = n === 0; countEl.textContent = n ? ' (' + n + ')' : ''; }
        if (showEl && resultEl) {
          const c = parseInt(resultEl.textContent, 10);
          showEl.textContent = isNaN(c) ? resultEl.textContent : c.toLocaleString('en-US');
          const btn = showEl.closest('button');
          if (btn) btn.lastChild.textContent = c === 1 ? ' diamond' : ' diamonds';
        }
      }
      if (resultEl) new MutationObserver(syncCounts).observe(resultEl, { childList: true, characterData: true, subtree: true });
      window.addEventListener('popstate', () => setTimeout(syncCounts, 50));
      let lastFocus = null;
      function openSheet() {
        lastFocus = document.activeElement;
        sheet.hidden = false;
        document.documentElement.classList.add('arelia-sheet-open');
        syncCounts();
        window.dispatchEvent(new Event('resize'));  // re-fit the search placeholder now it has width
        const first = sheet.querySelector('[data-m-filters-close]'); if (first) first.focus();
      }
      function closeSheet(scrollToResults) {
        if (sheet.hidden) return;
        sheet.hidden = true;
        document.documentElement.classList.remove('arelia-sheet-open');
        syncCounts();
        if (scrollToResults) {
          const target = root.querySelector('.arelia-col__search-bar') || root;
          window.scrollTo({ top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - 70), behavior: 'smooth' });
        } else if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      root.querySelectorAll('[data-m-filters-open]').forEach(b => b.addEventListener('click', openSheet));
      sheet.querySelectorAll('[data-m-filters-close]').forEach(b => b.addEventListener('click', () => closeSheet(true)));
      document.addEventListener('keydown', e => { if (e.key === 'Escape') closeSheet(false); });
      const apply = () => (mq.matches ? toPhone() : toDesktop());
      apply();
      if (mq.addEventListener) mq.addEventListener('change', apply); else mq.addListener(apply);
      syncCounts();
    }

    // Document-level: close popovers on outside click / Escape. Bound once.
    document.addEventListener('click', e => {
      document.querySelectorAll('.arelia-adv__popover:not([hidden])').forEach(pop => {
        const adv = pop.closest('.arelia-adv');
        if (adv && !adv.contains(e.target)) {
          pop.hidden = true;
          const trig = adv.querySelector('[data-adv-trigger]');
          if (trig) trig.setAttribute('aria-expanded', 'false');
        }
      });
    });
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.arelia-adv__popover:not([hidden])').forEach(pop => {
        pop.hidden = true;
        const adv = pop.closest('.arelia-adv');
        const trig = adv && adv.querySelector('[data-adv-trigger]');
        if (trig) trig.setAttribute('aria-expanded', 'false');
      });
    });

    // Hard key filter on numeric range inputs. <input type="number"> blocks
    // alpha keys in Chrome/Safari but Firefox accepts them; we force-block
    // anything that isn't a digit, decimal point, navigation key, or
    // copy/paste/select-all combo. Applied to both the headline Price/Carat
    // boxes and the Advanced Options popover boxes.
    document.addEventListener('keydown', e => {
      const el = e.target;
      if (!el || !el.classList) return;
      if (!el.classList.contains('arelia-numeric-input') && !el.classList.contains('arelia-adv__number')) return;
      if (e.metaKey || e.ctrlKey || e.altKey) return;  // allow Cmd/Ctrl shortcuts (copy, paste, select-all, etc.)
      const allowed = ['Backspace', 'Delete', 'Tab', 'Enter', 'Escape', 'Home', 'End',
                       'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
      if (allowed.includes(e.key)) return;
      if (/^[0-9.]$/.test(e.key)) {
        // Only allow one decimal point per field
        if (e.key === '.' && el.value.includes('.')) e.preventDefault();
        return;
      }
      e.preventDefault();
    });

    // Browser back/forward
    window.addEventListener('popstate', () => {
      refreshSection(window.location.pathname + window.location.search, { pushState: false });
    });

    // Fetch catalog bounds first, then init the UI. .finally() ensures
    // setupRoot still runs even if the bounds query fails or times out —
    // the static BOUNDS act as fallback so the section is never blocked.
    fetchCatalogBounds().finally(() => {
      setupRoot(getRoot());
      // Fire an initial Algolia fetch so the table is populated by sorted
      // (shape-priority) hits instead of the server-rendered Liquid view
      // (which is Shopify's Heart-first natural collection order).
      refreshSection(window.location.pathname + window.location.search, { pushState: false });
    });
  })();

